"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PIPELINE_STEP_KEYS = exports.LOCAL_STEP_KEYS = exports.COMMENT_NOT_ADDED_REDLINE_NOT_APPLIED = exports.COMMENT_NOT_ADDED_PARAGRAPH_GONE = exports.BulkApplyRunProvider = exports.BULK_APPLY_STEP_STATUSES = void 0;
exports.useBulkApplyRun = useBulkApplyRun;
var _react = _interopRequireWildcard(require("react"));
var _zod = require("zod");
var _appliedActions = require("@common/constants/appliedActions");
var _redlinePayload = require("@common/utils/redline/wire/redline-payload");
var _redlinePlacement = require("@common/utils/redline/wire/redline-placement");
var _anchorTrackerRegistry = require("../utils/anchor/anchor-tracker-registry");
var _cardTargetState = require("../components/chat/proposal-card/card-target-state");
var _commentTargetRecovery = require("../components/chat/proposal-card/comment-target-recovery");
var _pageRevisions = require("../components/chat/proposal-tracker/page-revisions");
var _proposalApplier = require("../utils/anchor/proposal/proposal-applier");
var _recoveryConfig = require("../utils/anchor/recovery-config");
var _bulkApplyMergeEntry = require("../utils/bulk-apply-merge-entry");
var _bulkApplyPayloadStats = require("../utils/bulk-apply-payload-stats");
var _bulkMergeWriteSummary = require("../utils/bulk-merge-write-summary");
var _document = require("../utils/document");
var _ooxmlRecovery = require("../utils/ooxml-recovery");
var _sentryReporter = require("../utils/sentry-reporter");
var _bulkApplyRunTimeline = require("../utils/bulk-apply-run-timeline");
var _api = require("../utils/api");
var _proposalEngineAccess = require("../utils/proposal-engine-access");
var _redlineAppliedCards = require("../utils/redline-applied-cards");
var _cardCommentSelections = require("../components/chat/proposal-card/card-comment-selections");
var _changeThroughoutRunOutcome = require("../components/chat/proposal-card/change-throughout-run-outcome");
var _redlineLandingPageFacts = require("../utils/redline-landing-page-facts");
var _redlineLandingReconciliation = require("../utils/redline-landing-reconciliation");
var _redlineBulkApplyLocal = require("../utils/redline-bulk-apply-local");
var _redlineInsertionSlot = require("../utils/redline-insertion-slot");
var _tableOfContentsFields = require("../utils/table-of-contents-fields");
var _safeFetch = require("../utils/safe-fetch");
var _errors = require("../utils/errors");
var _toast = require("../utils/toast");
var _AnalyticsContext = require("./AnalyticsContext");
var _AuthContext = require("./AuthContext");
var _ChatContext = require("./ChatContext");
var _ReviewedDocumentContext = require("./ReviewedDocumentContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t23 in e) "default" !== _t23 && {}.hasOwnProperty.call(e, _t23) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t23)) && (i.get || i.set) ? o(f, _t23, i) : f[_t23] = e[_t23]); return f; })(e, t); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * The one bulk apply run of the add-in, owned here at the app root so that no
 * re-render, unmount or remount of the message, drawer or page that started it can
 * lose it (2026-09-22: a review's Apply All vanished with the drawer's re-render and
 * the panel never opened). Chat, the review drawer and the review page start a run
 * through `startRun`; the progress panel is a view over this context and mounts
 * once at the root.
 *
 * Two kinds of run:
 *   - pipeline: the server's six steps, followed through the status file it writes;
 *     the entries each step hands back are written here
 *   - local: the add-in folds the cards itself (`localBulkApplyEntries`), the core is
 *     reached once for the paragraphs whose cards collide, and the entries are
 *     written here; its steps are the conflict check and the three writes, a write
 *     shown only when the run has something for it
 */
var BULK_APPLY_STEP_STATUSES = exports.BULK_APPLY_STEP_STATUSES = ["QUEUED", "IN_PROGRESS", "COMPLETED", "FAILED"];
var PIPELINE_STEP_KEYS = exports.PIPELINE_STEP_KEYS = ["gathering_data", "finding_conflicts", "merging_non_conflicting_issues", "solving_conflicts", "merging_conflicting_issues", "applying_comments"];
var LOCAL_STEP_KEYS = exports.LOCAL_STEP_KEYS = ["checking_conflicts", "applying_redlines", "applying_table_changes", "finding_moved_changes", "adding_comments"];
var STEP_TITLES = {
  gathering_data: "Gathering Data",
  finding_conflicts: "Finding Conflicts",
  merging_non_conflicting_issues: "Merging Non-Conflicting Issues",
  solving_conflicts: "Solving Conflicts",
  merging_conflicting_issues: "Merging Conflicting Issues",
  applying_comments: "Applying Comments",
  checking_conflicts: "Checking for conflicts",
  applying_redlines: "Applying redlines",
  applying_table_changes: "Applying table changes",
  finding_moved_changes: "Finding moved changes",
  adding_comments: "Adding comments"
};
var STEP_DESCRIPTIONS = {
  gathering_data: "Processing selected rules and analyzing requirements",
  finding_conflicts: "Identifying potential conflicts between rule applications",
  merging_non_conflicting_issues: "Applying rules that don't conflict with each other",
  solving_conflicts: "Resolving conflicts between overlapping rule applications",
  merging_conflicting_issues: "Finalizing all rule applications and generating results",
  applying_comments: "Preparing and applying comment suggestions to the document",
  checking_conflicts: "Looking for changes that overlap",
  applying_redlines: "Writing the changes into the document",
  applying_table_changes: "Writing the table changes into the document",
  finding_moved_changes: "Looking for the changes whose paragraphs moved, then writing them",
  adding_comments: "Adding the comments to the document"
};

/**
 * WHEN a step in the redline pipeline fails, the document plan is incomplete: a
 * later step would have amended the regions an earlier one merged, so nothing
 * further may be written.
 * CONSEQUENCE applying_comments sits outside this set. A comment that cannot be
 * anchored does not invalidate redlines the pipeline already produced, so its
 * failure costs only the rules that were owed a comment.
 */
var REDLINE_PIPELINE_STEP_KEYS = ["gathering_data", "finding_conflicts", "merging_non_conflicting_issues", "solving_conflicts", "merging_conflicting_issues"];
var REDLINE_WRITE_STEP_KEYS = ["applying_redlines", "applying_table_changes", "finding_moved_changes", "merging_non_conflicting_issues", "merging_conflicting_issues"];
var COMMENT_WRITE_STEP_KEYS = ["adding_comments", "applying_comments"];

/** A rule the run was asked to apply; `reason` is the sentence the run gave for not applying it, when it gave one. */

var COMMENT_NOT_ADDED_PARAGRAPH_GONE = exports.COMMENT_NOT_ADDED_PARAGRAPH_GONE = "Not added: the paragraph it belongs to is no longer in the document.";
var COMMENT_NOT_ADDED_REDLINE_NOT_APPLIED = exports.COMMENT_NOT_ADDED_REDLINE_NOT_APPLIED = "Not added: the redline it belongs to did not apply.";

/**
 * What a run reports when it settles: the rules it credited, the rules it failed with
 * their reasons, the cards the fold dropped, the rules whose redline and whose comment
 * landed, each on its own, the rules a choice kept nowhere, which were never tried and
 * never failed, and the credited rules a choice gave part of to another card.
 */

var BulkApplyRunContext = /*#__PURE__*/(0, _react.createContext)(null);
var ruleAttributionSchema = _zod.z.object({
  rule_uuids: _zod.z.array(_zod.z.string()),
  rule_names: _zod.z.array(_zod.z.string()).optional()
});
var commentEntrySchema = _zod.z.object({
  target_bookmark_names: _zod.z.array(_zod.z.string()),
  comment_text: _zod.z.string(),
  target_text: _zod.z.string(),
  placement: _zod.z.enum(["first_word", "span", "after_paragraph"]).nullish(),
  anchor_text: _zod.z.string().nullish(),
  rule_uuids: _zod.z.array(_zod.z.string()).optional(),
  rule_names: _zod.z.array(_zod.z.string()).optional()
});
var stepStatusSchema = function stepStatusSchema(data) {
  return _zod.z.object({
    status: _zod.z.enum(BULK_APPLY_STEP_STATUSES),
    details: _zod.z.string().optional(),
    data: data.optional()
  }).partial({
    status: true
  });
};
var bulkApplyStatusSchema = _zod.z.object({
  gathering_data: stepStatusSchema(_zod.z.unknown()).optional(),
  finding_conflicts: stepStatusSchema(_zod.z.unknown()).optional(),
  merging_non_conflicting_issues: stepStatusSchema(_zod.z.object({
    merge_data: _zod.z.array(_bulkApplyMergeEntry.BulkApplyMergeEntrySchema).optional(),
    already_applied_changes: _zod.z.array(ruleAttributionSchema).optional(),
    error_changes: _zod.z.array(ruleAttributionSchema).optional()
  })).optional(),
  solving_conflicts: stepStatusSchema(_zod.z.object({
    error_changes: _zod.z.array(ruleAttributionSchema).optional()
  })).optional(),
  merging_conflicting_issues: stepStatusSchema(_zod.z.object({
    merge_data: _zod.z.array(_bulkApplyMergeEntry.BulkApplyMergeEntrySchema).optional()
  })).optional(),
  applying_comments: stepStatusSchema(_zod.z.object({
    comment_data: _zod.z.array(commentEntrySchema).optional()
  })).optional()
});
var BULK_APPLY_STALL_TIMEOUT_MS = 180000;
var BULK_APPLY_STALL_MESSAGE = "Bulk apply made no progress for 3 minutes";
var BULK_APPLY_POLL_INTERVAL_MS = 2000;
var BULK_APPLY_POLL_MAX_BACKOFF_MS = 30000;
var stepKeysOf = function stepKeysOf(kind) {
  return kind === "local" ? LOCAL_STEP_KEYS : PIPELINE_STEP_KEYS;
};
var createStepStates = function createStepStates(kind) {
  return Object.fromEntries(stepKeysOf(kind).map(function (key) {
    return [key, {
      completed: false,
      applied: false
    }];
  }));
};
var stepProgressFingerprint = function stepProgressFingerprint(data) {
  return PIPELINE_STEP_KEYS.map(function (key) {
    var _data$key$status, _data$key, _data$key$details, _data$key2;
    return "".concat(key, ":").concat((_data$key$status = (_data$key = data[key]) === null || _data$key === void 0 ? void 0 : _data$key.status) !== null && _data$key$status !== void 0 ? _data$key$status : "QUEUED", ":").concat((_data$key$details = (_data$key2 = data[key]) === null || _data$key2 === void 0 ? void 0 : _data$key2.details) !== null && _data$key$details !== void 0 ? _data$key$details : "");
  }).join("|");
};
var resolveApplyBar = function resolveApplyBar(steps, isRepairing, progress, outcome, appliedRuleCount, failedRuleCount, commentsNotAddedCount) {
  if (outcome === "failed") {
    return {
      tone: "failed",
      label: "Couldn't apply these changes",
      count: "",
      percent: null
    };
  }
  if (outcome === "partial") {
    /** Singular only when exactly one rule still needs a human: "1 rule needs review". */
    var rulesNeed = failedRuleCount === 1 ? "rule needs" : "rules need";
    var rulesNote = failedRuleCount === 0 ? "" : "".concat(failedRuleCount, " ").concat(rulesNeed, " review");
    var commentsNote = commentsNotAddedCount === 0 ? "" : "".concat(commentsNotAddedCount, " ").concat(commentsNotAddedCount === 1 ? "comment" : "comments", " not added");
    var notes = [rulesNote, commentsNote].filter(function (note) {
      return note !== "";
    });
    return {
      tone: "partial",
      label: ["".concat(appliedRuleCount, " applied")].concat(_toConsumableArray(notes)).join(", "),
      count: "",
      percent: null
    };
  }
  if (outcome === "done") {
    var changes = appliedRuleCount === 1 ? "change" : "changes";
    return {
      tone: "done",
      label: "All ".concat(appliedRuleCount, " ").concat(changes, " applied"),
      count: "",
      percent: null
    };
  }
  if (isRepairing) {
    return {
      tone: "running",
      label: "Repairing a redline",
      count: "",
      percent: null
    };
  }
  if (progress) {
    return {
      tone: "running",
      label: STEP_TITLES[progress.stepKey],
      count: "".concat(progress.processed, " / ").concat(progress.total),
      /** EXAMPLE processed=3 total=4 -> 75. A zero total would divide by zero, and a step with nothing to process has made all the progress it can. */
      percent: progress.total > 0 ? Math.round(progress.processed / progress.total * 100) : 0
    };
  }
  /** WHEN no write is in flight, name the step that is running rather than reading as idle. */
  var runningStep = steps.find(function (step) {
    return step.status === "IN_PROGRESS";
  });
  return {
    tone: "running",
    label: runningStep ? runningStep.title : "Applying changes",
    count: "",
    percent: null
  };
};

/**
 * RETURNS the tone the finished run settles on.
 * CASES every step clean and every rule credited -> 'done'; every step clean but
 * some rule uncredited -> 'partial'; a step that did not finish cleanly -> 'partial'
 * when something still landed in the document, 'failed' when nothing did.
 */
var appliedToastMessageOf = function appliedToastMessageOf(notChosenCount, commentsNotAddedCount) {
  var conflictNote = notChosenCount === 0 ? "" : " ".concat(notChosenCount === 1 ? "One that conflicted was" : "".concat(notChosenCount, " that conflicted were"), " left for your review.");
  var commentsNote = commentsNotAddedCount === 0 ? "" : " ".concat(commentsNotAddedCount === 1 ? "One comment was not added; its card says why." : "".concat(commentsNotAddedCount, " comments were not added; each card says why."));
  return conflictNote === "" && commentsNote === "" ? "Your redlines have been applied" : "Your redlines have been applied.".concat(conflictNote).concat(commentsNote);
};
var resolveApplyOutcome = function resolveApplyOutcome(everyStepFinishedCleanly, everyRuleApplied, appliedRuleCount) {
  if (everyStepFinishedCleanly) return everyRuleApplied ? "done" : "partial";
  return appliedRuleCount > 0 ? "partial" : "failed";
};
var collectRuleIds = function collectRuleIds(entries) {
  var ids = entries.flatMap(function (entry) {
    var _entry$rule_uuids;
    return (_entry$rule_uuids = entry.rule_uuids) !== null && _entry$rule_uuids !== void 0 ? _entry$rule_uuids : [];
  }).filter(function (ruleId) {
    return Boolean(ruleId);
  });
  return Array.from(new Set(ids));
};
var cardToApplyOf = function cardToApplyOf(remedy) {
  return {
    bookmarkNames: remedy.target_bookmark_names,
    redline: remedy.target_texts === null ? null : (0, _redlinePayload.textsPayloadFrom)(remedy.target_texts)
  };
};
var isPlacedBeside = function isPlacedBeside(_ref) {
  var remedy = _ref.remedy,
    placement = _ref.placement;
  return remedy.target_texts !== null && (0, _redlinePlacement.relocatesBesideParagraph)(placement);
};
var remediesByPlacementOf = function remediesByPlacementOf(placedRemedies) {
  return {
    laidOnTheirParagraphs: placedRemedies.filter(function (placedRemedy) {
      return !isPlacedBeside(placedRemedy);
    }).map(function (_ref2) {
      var remedy = _ref2.remedy;
      return remedy;
    }),
    placedBesideParagraphs: placedRemedies.filter(isPlacedBeside).map(function (_ref3) {
      var remedy = _ref3.remedy;
      return remedy;
    })
  };
};
var firstPassOf = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(remedies) {
    var firstPass, cardIndexesLeftForTheServer, placedRemedies;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return _anchorTrackerRegistry.anchorTrackers.placementsForApply(remedies.map(cardToApplyOf));
        case 1:
          firstPass = _context.v;
          cardIndexesLeftForTheServer = new Set(firstPass.cardIndexesLeftForTheServer);
          placedRemedies = remedies.flatMap(function (remedy, cardIndex) {
            return cardIndexesLeftForTheServer.has(cardIndex) ? [] : [{
              remedy: remedy,
              placement: firstPass.placements[cardIndex]
            }];
          });
          return _context.a(2, _objectSpread(_objectSpread({}, remediesByPlacementOf(placedRemedies)), {}, {
            leftForTheServer: remedies.filter(function (_remedy, cardIndex) {
              return cardIndexesLeftForTheServer.has(cardIndex);
            }),
            documentPages: firstPass.documentPages
          }));
      }
    }, _callee);
  }));
  return function firstPassOf(_x) {
    return _ref4.apply(this, arguments);
  };
}();
var serverPassOf = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(leftForTheServer) {
    var serverPass, serverPlacementOf, placedRemedies;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return _anchorTrackerRegistry.anchorTrackers.placementsFromTheServer(leftForTheServer.map(cardToApplyOf));
        case 1:
          serverPass = _context2.v;
          serverPlacementOf = function serverPlacementOf(cardIndex) {
            var _serverPass$placement;
            return (_serverPass$placement = serverPass.placements[cardIndex]) !== null && _serverPass$placement !== void 0 ? _serverPass$placement : null;
          };
          placedRemedies = leftForTheServer.flatMap(function (remedy, cardIndex) {
            var placement = serverPlacementOf(cardIndex);
            return placement === null ? [] : [{
              remedy: remedy,
              placement: placement
            }];
          });
          return _context2.a(2, _objectSpread(_objectSpread({}, remediesByPlacementOf(placedRemedies)), {}, {
            notFoundByTheServer: leftForTheServer.filter(function (_remedy, cardIndex) {
              return serverPlacementOf(cardIndex) === null;
            }),
            documentPages: serverPass.documentPages
          }));
      }
    }, _callee2);
  }));
  return function serverPassOf(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
var isCardForTheApplier = function isCardForTheApplier(entry) {
  return "card" in entry;
};
var isMergeEntry = function isMergeEntry(entry) {
  return !isCardForTheApplier(entry);
};
var textCardTargetsOf = function textCardTargetsOf(cards) {
  return cards.flatMap(function (entry) {
    return entry.rule_uuids.map(function (ruleId) {
      return {
        kind: "text_card",
        ruleId: ruleId,
        bookmarkNames: entry.target_bookmark_names,
        card: entry.card,
        insertsAfterBookmarks: false
      };
    });
  });
};
var BulkApplyRunProvider = exports.BulkApplyRunProvider = function BulkApplyRunProvider(_ref6) {
  var children = _ref6.children;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var applyBulkMerge = (0, _ooxmlRecovery.useApplyBulkMergeData)();
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    addRespondedRules = _useReviewedDocument.addRespondedRules;
  var _useChat = (0, _ChatContext.useChat)(),
    messagesHistory = _useChat.messagesHistory,
    selectedConversationId = _useChat.selectedConversationId;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var chatRef = (0, _react.useRef)({
    messagesHistory: messagesHistory,
    selectedConversationId: selectedConversationId,
    authHeader: authHeader
  });
  chatRef.current = {
    messagesHistory: messagesHistory,
    selectedConversationId: selectedConversationId,
    authHeader: authHeader
  };
  var slotInsertionsSharedWithTableStepRef = (0, _react.useRef)([]);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    request = _useState2[0],
    setRequest = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    runKind = _useState4[0],
    setRunKind = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPanelOpen = _useState6[0],
    setIsPanelOpen = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isRunning = _useState8[0],
    setIsRunning = _useState8[1];
  var _useState9 = (0, _react.useState)({}),
    _useState0 = _slicedToArray(_useState9, 2),
    stepRecords = _useState0[0],
    setStepRecords = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    hiddenStepKeys = _useState10[0],
    setHiddenStepKeys = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isRepairing = _useState12[0],
    setIsRepairing = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    applyProgress = _useState14[0],
    setApplyProgress = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    appliedRuleCount = _useState16[0],
    setAppliedRuleCount = _useState16[1];
  var _useState17 = (0, _react.useState)(0),
    _useState18 = _slicedToArray(_useState17, 2),
    commentsNotAddedCount = _useState18[0],
    setCommentsNotAddedCount = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    failedRules = _useState20[0],
    setFailedRules = _useState20[1];
  var _useState21 = (0, _react.useState)([]),
    _useState22 = _slicedToArray(_useState21, 2),
    failedCardDetails = _useState22[0],
    setFailedCardDetails = _useState22[1];
  var _useState23 = (0, _react.useState)(null),
    _useState24 = _slicedToArray(_useState23, 2),
    outcome = _useState24[0],
    setOutcome = _useState24[1];
  var requestRef = (0, _react.useRef)(null);
  var runKindRef = (0, _react.useRef)(null);
  var runStartedAtMsRef = (0, _react.useRef)(Date.now());
  var mergeWritesRef = (0, _react.useRef)([]);
  var bodyReadOfTheMergesRef = (0, _react.useRef)(null);
  var statusFileUrlRef = (0, _react.useRef)("");
  var pipelineRemediesRef = (0, _react.useRef)([]);
  var remediesOfTheRunRef = (0, _react.useRef)([]);
  var failedRulesRef = (0, _react.useRef)([]);
  var droppedCardsRef = (0, _react.useRef)([]);
  var writtenLandingTargetsRef = (0, _react.useRef)([]);
  var notChosenRuleIdsRef = (0, _react.useRef)([]);
  var notChosenCardsRef = (0, _react.useRef)([]);
  var partlySupersededCardsRef = (0, _react.useRef)([]);
  var cardsAsWrittenRef = (0, _react.useRef)([]);
  var foldPartlyAppliedCardsRef = (0, _react.useRef)([]);
  var succeededByStepRef = (0, _react.useRef)(new Map());
  var failedByStepRef = (0, _react.useRef)(new Map());
  var partiallyAppliedRuleIdsRef = (0, _react.useRef)([]);
  /** The credited cards the applier wrote in part, each with the reason the card shows (`applyCardsOneByOne`). */
  var partiallyAppliedCardsRef = (0, _react.useRef)([]);
  var isPollingRef = (0, _react.useRef)(false);
  var isRunningRef = (0, _react.useRef)(false);
  var pollGenerationRef = (0, _react.useRef)(0);
  var timelineRunRef = (0, _react.useRef)(null);
  var pollingRef = (0, _react.useRef)(null);
  var lastProgressAtRef = (0, _react.useRef)(null);
  var lastStatusSnapshotRef = (0, _react.useRef)(null);
  var consecutivePollFailuresRef = (0, _react.useRef)(0);
  var stepsRef = (0, _react.useRef)({});
  var applyChainRef = (0, _react.useRef)(Promise.resolve());
  var accumulatedSuccessRef = (0, _react.useRef)(new Set());
  var accumulatedFailedRef = (0, _react.useRef)(new Set());
  var heldBackCommentRuleIdsRef = (0, _react.useRef)(new Set());
  var writtenPackageOoxmlsRef = (0, _react.useRef)([]);
  var commentOutcomesRef = (0, _react.useRef)([]);
  var commentsNotWrittenRef = (0, _react.useRef)([]);
  /** WHEN set, the run can make no further progress, so tryComplete settles it instead of waiting for steps that will never finish. */
  var runCannotContinueRef = (0, _react.useRef)(false);
  /** WHEN set, applying_comments failed while the rest of the run carried on, so the finish is never clean. */
  var hasServerFailedStepRef = (0, _react.useRef)(false);
  var completionTriggeredRef = (0, _react.useRef)(false);
  var markStep = function markStep(key, status) {
    var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setStepRecords(function (previous) {
      return _objectSpread(_objectSpread({}, previous), {}, _defineProperty({}, key, {
        status: status,
        details: details
      }));
    });
  };
  var appendFailedRules = function appendFailedRules(entries) {
    var normalized = collectRuleIds(entries);
    if (normalized.length === 0) return;
    var metadata = new Map();
    entries.forEach(function (entry) {
      var _entry$rule_uuids2;
      (_entry$rule_uuids2 = entry.rule_uuids) === null || _entry$rule_uuids2 === void 0 || _entry$rule_uuids2.forEach(function (ruleId, index) {
        var _entry$rule_names;
        if (!ruleId || metadata.has(ruleId)) return;
        metadata.set(ruleId, (_entry$rule_names = entry.rule_names) === null || _entry$rule_names === void 0 ? void 0 : _entry$rule_names[index]);
      });
    });
    var reasonOf = new Map(droppedCardsRef.current.map(function (dropped) {
      return [dropped.ruleId, dropped.reason];
    }));
    var currentMap = new Map(failedRulesRef.current.map(function (rule) {
      return [rule.ruleId, rule];
    }));
    var updated = false;
    normalized.forEach(function (ruleId) {
      var _metadata$get, _reasonOf$get;
      var existing = currentMap.get(ruleId);
      var ruleName = (_metadata$get = metadata.get(ruleId)) !== null && _metadata$get !== void 0 ? _metadata$get : existing === null || existing === void 0 ? void 0 : existing.ruleName;
      var reason = (_reasonOf$get = reasonOf.get(ruleId)) !== null && _reasonOf$get !== void 0 ? _reasonOf$get : existing === null || existing === void 0 ? void 0 : existing.reason;
      if (!existing || existing.ruleName !== ruleName || existing.reason !== reason) {
        currentMap.set(ruleId, {
          ruleId: ruleId,
          ruleName: ruleName,
          reason: reason
        });
        updated = true;
      }
    });
    if (!updated) return;
    var newFailedRules = Array.from(currentMap.values());
    failedRulesRef.current = newFailedRules;
    setFailedRules(newFailedRules);
  };
  var recordFailedRules = function recordFailedRules(entries) {
    appendFailedRules(entries);
    collectRuleIds(entries).forEach(function (ruleId) {
      return accumulatedFailedRef.current.add(ruleId);
    });
  };
  var applyData = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data, applyFn, errorMessage, actionName) {
      var appliedRuleIds, _result$heldBackRuleI, result, failedRuleIds, heldBackRuleIds, successfulRuleIds, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            appliedRuleIds = collectRuleIds(data);
            _context3.p = 1;
            _context3.n = 2;
            return applyFn(data, sendError);
          case 2:
            result = _context3.v;
            failedRuleIds = Array.from(new Set(result.failedRuleIds));
            heldBackRuleIds = (_result$heldBackRuleI = result.heldBackRuleIds) !== null && _result$heldBackRuleI !== void 0 ? _result$heldBackRuleI : [];
            successfulRuleIds = appliedRuleIds.filter(function (id) {
              return !failedRuleIds.includes(id) && !heldBackRuleIds.includes(id);
            });
            return _context3.a(2, {
              failedRuleIds: failedRuleIds,
              successfulRuleIds: successfulRuleIds,
              heldBackRuleIds: heldBackRuleIds
            });
          case 3:
            _context3.p = 3;
            _t = _context3.v;
            console.error("Error in bulk apply (".concat(actionName, "):"), _t);
            (0, _toast.toastError)(errorMessage);
            sendError(_t, {
              component: "BulkApplyRunProvider",
              action: actionName,
              data: data
            });
            return _context3.a(2, {
              failedRuleIds: appliedRuleIds,
              successfulRuleIds: [],
              heldBackRuleIds: []
            });
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function applyData(_x3, _x4, _x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();

  /** Every rule the run was asked to apply and neither credited nor named as failed is reported as failed rather than left unaccounted. */
  var recordStepOutcome = function recordStepOutcome(stepKey, succeededRuleIds, failedRuleIds) {
    var _succeededByStepRef$c, _failedByStepRef$curr;
    var succeeded = (_succeededByStepRef$c = succeededByStepRef.current.get(stepKey)) !== null && _succeededByStepRef$c !== void 0 ? _succeededByStepRef$c : new Set();
    succeededRuleIds.forEach(function (ruleId) {
      return succeeded.add(ruleId);
    });
    succeededByStepRef.current.set(stepKey, succeeded);
    var failed = (_failedByStepRef$curr = failedByStepRef.current.get(stepKey)) !== null && _failedByStepRef$curr !== void 0 ? _failedByStepRef$curr : new Set();
    failedRuleIds.forEach(function (ruleId) {
      return failed.add(ruleId);
    });
    failedByStepRef.current.set(stepKey, failed);
  };
  var ruleIdsLandedInSteps = function ruleIdsLandedInSteps(stepKeys) {
    var failed = new Set(stepKeys.flatMap(function (stepKey) {
      var _failedByStepRef$curr2;
      return Array.from((_failedByStepRef$curr2 = failedByStepRef.current.get(stepKey)) !== null && _failedByStepRef$curr2 !== void 0 ? _failedByStepRef$curr2 : []);
    }));
    var succeeded = new Set(stepKeys.flatMap(function (stepKey) {
      var _succeededByStepRef$c2;
      return Array.from((_succeededByStepRef$c2 = succeededByStepRef.current.get(stepKey)) !== null && _succeededByStepRef$c2 !== void 0 ? _succeededByStepRef$c2 : []);
    }));
    return Array.from(succeeded).filter(function (ruleId) {
      return !failed.has(ruleId);
    });
  };
  var appendUnreportedRules = function appendUnreportedRules(creditedRuleIds) {
    var _requestRef$current$r, _requestRef$current;
    var rules = (_requestRef$current$r = (_requestRef$current = requestRef.current) === null || _requestRef$current === void 0 ? void 0 : _requestRef$current.rules) !== null && _requestRef$current$r !== void 0 ? _requestRef$current$r : [];
    var unreported = rules.filter(function (rule) {
      return !creditedRuleIds.includes(rule.ruleId) && !accumulatedFailedRef.current.has(rule.ruleId) && !notChosenRuleIdsRef.current.includes(rule.ruleId) && !heldBackCommentRuleIdsRef.current.has(rule.ruleId);
    });
    if (unreported.length === 0) return;
    recordFailedRules(unreported.map(function (rule) {
      var _rule$ruleName;
      return {
        rule_uuids: [rule.ruleId],
        rule_names: [(_rule$ruleName = rule.ruleName) !== null && _rule$ruleName !== void 0 ? _rule$ruleName : rule.ruleId]
      };
    }));
  };
  var refreshTableOfContentsAfterBulkApply = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(writtenPackageOoxmlsOfTheSettledRun) {
      var _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            _context4.n = 1;
            return (0, _tableOfContentsFields.updateTableOfContentsFields)(writtenPackageOoxmlsOfTheSettledRun);
          case 1:
            _context4.n = 3;
            break;
          case 2:
            _context4.p = 2;
            _t2 = _context4.v;
            sendError(_t2 instanceof Error ? _t2 : new Error(String(_t2)), {
              component: "BulkApplyRunProvider",
              action: "update_table_of_contents"
            });
          case 3:
            return _context4.a(2);
        }
      }, _callee4, null, [[0, 2]]);
    }));
    return function refreshTableOfContentsAfterBulkApply(_x7) {
      return _ref8.apply(this, arguments);
    };
  }();

  /**
   * Settles the run once it can produce nothing further, whether it finished its
   * steps or gave up. A rule is credited only if it succeeded in every step that
   * owed it work and failed in none.
   */
  var tryComplete = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var _requestRef$current$r2, _requestRef$current2, _requestRef$current3, _requestRef$current4, _requestRef$current4$;
      var stepStates, everyStepFinished, settledGeneration, settledTimelineRun, landingsAreAudited, creditedRuleIds, tableOfContentsIsRefreshed, bulkRunOutcome, creditedCardIds, placeRuleIdsOfCreditedCards, bookmarkNamesOfRule, everyStepFinishedCleanly, everyRuleLanded, commentsNotAddedCount, everyRuleApplied, timelineAtCompletion, timelineSnapshotAtMs, _t3;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (!completionTriggeredRef.current) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            stepStates = Object.values(stepsRef.current);
            everyStepFinished = stepStates.every(function (step) {
              return step.completed;
            });
            if (!(!everyStepFinished && !runCannotContinueRef.current)) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2);
          case 2:
            completionTriggeredRef.current = true;
            isPollingRef.current = false;
            setApplyProgress(null);
            settledGeneration = pollGenerationRef.current;
            settledTimelineRun = timelineRunRef.current;
            landingsAreAudited = everyStepFinished && !runCannotContinueRef.current;
            /** A run that never reached the end credits nothing: a step that never reported cannot vouch for the rules it was handed. */
            creditedRuleIds = everyStepFinished ? Array.from(accumulatedSuccessRef.current).filter(function (id) {
              return !accumulatedFailedRef.current.has(id) && !notChosenRuleIdsRef.current.includes(id);
            }) : [];
            appendUnreportedRules(creditedRuleIds);
            setAppliedRuleCount(creditedRuleIds.length);
            tableOfContentsIsRefreshed = runKindRef.current === "local" && creditedRuleIds.length > 0;
            bulkRunOutcome = {
              runKind: runKindRef.current,
              creditedRuleIds: creditedRuleIds,
              failedRules: failedRulesRef.current,
              droppedCards: droppedCardsRef.current,
              partiallyAppliedRuleIds: partiallyAppliedRuleIdsRef.current,
              partiallyAppliedCards: partiallyAppliedCardsRef.current,
              redlineAppliedRuleIds: everyStepFinished ? ruleIdsLandedInSteps(REDLINE_WRITE_STEP_KEYS) : [],
              commentAppliedRuleIds: everyStepFinished ? ruleIdsLandedInSteps(COMMENT_WRITE_STEP_KEYS) : [],
              commentOutcomes: commentOutcomesRef.current,
              notChosenRuleIds: notChosenRuleIdsRef.current,
              notChosenCards: notChosenCardsRef.current,
              partlySupersededCards: partlySupersededCardsRef.current.filter(function (card) {
                return creditedRuleIds.includes(card.ruleId);
              }),
              mergeWrite: (0, _bulkMergeWriteSummary.combinedMergeWriteSummary)(mergeWritesRef.current),
              runDurationMs: Date.now() - runStartedAtMsRef.current,
              timeline: (0, _bulkApplyRunTimeline.snapshotBulkApplyTimeline)(settledTimelineRun)
            };
            creditedCardIds = new Set(creditedRuleIds.map(_redlineAppliedCards.cardIdOfRuleId));
            placeRuleIdsOfCreditedCards = ((_requestRef$current$r2 = (_requestRef$current2 = requestRef.current) === null || _requestRef$current2 === void 0 ? void 0 : _requestRef$current2.rules) !== null && _requestRef$current$r2 !== void 0 ? _requestRef$current$r2 : []).map(function (rule) {
              return rule.ruleId;
            }).filter(function (ruleId) {
              return (0, _redlineAppliedCards.isChangeThroughoutPlaceRuleId)(ruleId) && creditedCardIds.has((0, _redlineAppliedCards.cardIdOfRuleId)(ruleId));
            });
            bookmarkNamesOfRule = function bookmarkNamesOfRule(ruleId) {
              var _remediesOfTheRunRef$, _remediesOfTheRunRef$2;
              return (_remediesOfTheRunRef$ = (_remediesOfTheRunRef$2 = remediesOfTheRunRef.current.find(function (remedy) {
                return remedy.rule_uuid === ruleId;
              })) === null || _remediesOfTheRunRef$2 === void 0 ? void 0 : _remediesOfTheRunRef$2.target_bookmark_names) !== null && _remediesOfTheRunRef$ !== void 0 ? _remediesOfTheRunRef$ : [];
            };
            (0, _redlineAppliedCards.tellAgentsCardsApplied)([].concat(_toConsumableArray(writtenLandingTargetsRef.current.filter(function (_ref0) {
              var target = _ref0.target;
              return creditedRuleIds.includes(target.ruleId);
            }).map(function (_ref1) {
              var target = _ref1.target;
              return (0, _redlineAppliedCards.appliedCardOfLandingTarget)(target, partiallyAppliedRuleIdsRef.current.includes(target.ruleId));
            })), _toConsumableArray(commentsNotWrittenRef.current.filter(function (_ref10) {
              var target = _ref10.target;
              return (0, _cardCommentSelections.isCardCommentKey)(target.ruleId) && creditedCardIds.has((0, _redlineAppliedCards.cardIdOfRuleId)(target.ruleId));
            }).map(function (_ref11) {
              var target = _ref11.target,
                paragraphGone = _ref11.paragraphGone;
              return (0, _redlineAppliedCards.commentNotWrittenReportOf)({
                cardId: (0, _redlineAppliedCards.cardIdOfRuleId)(target.ruleId),
                paragraphBookmarkNames: target.bookmarkNames,
                text: target.commentText,
                quotedText: target.quotedText
              }, (0, _errors.commentNotWrittenCauseOf)(paragraphGone));
            })), _toConsumableArray((0, _changeThroughoutRunOutcome.placesNotAppliedOf)(placeRuleIdsOfCreditedCards, bulkRunOutcome).map(function (_ref12) {
              var ruleId = _ref12.ruleId,
                outcome = _ref12.outcome;
              return (0, _redlineAppliedCards.placeNotAppliedReportOf)(ruleId, bookmarkNamesOfRule(ruleId), outcome);
            }))));
            everyStepFinishedCleanly = everyStepFinished && !runCannotContinueRef.current && !hasServerFailedStepRef.current;
            everyRuleLanded = everyStepFinishedCleanly && failedRulesRef.current.length === 0;
            commentsNotAddedCount = new Set(commentOutcomesRef.current.filter(function (commentOutcome) {
              return commentOutcome.result === "heldBack";
            }).map(function (commentOutcome) {
              return commentOutcome.ruleId;
            })).size;
            everyRuleApplied = everyRuleLanded && commentsNotAddedCount === 0;
            setCommentsNotAddedCount(commentsNotAddedCount);

            /** A credited rule is marked responded whatever the run's outcome, so the review state and the outcome the caller receives never disagree about what landed. */
            if (!(creditedRuleIds.length > 0)) {
              _context5.n = 6;
              break;
            }
            _context5.p = 3;
            _context5.n = 4;
            return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("responded_rules_saved", function () {
              return addRespondedRules(creditedRuleIds);
            }, {
              rules: creditedRuleIds.length
            });
          case 4:
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t3 = _context5.v;
            console.error("Failed to mark rules as responded:", _t3);
          case 6:
            /** Only a clean finish is announced as success; an unclean one is left to the bar, which names the shortfall. */
            if (everyStepFinishedCleanly) {
              (0, _toast.toastSuccess)(everyRuleLanded ? appliedToastMessageOf(notChosenRuleIdsRef.current.length, commentsNotAddedCount) : "Bulk apply complete. Some rules failed to apply - please review.");
            }
            setOutcome(resolveApplyOutcome(everyStepFinishedCleanly, everyRuleApplied, creditedRuleIds.length));
            isRunningRef.current = false;
            setIsRunning(false);
            timelineAtCompletion = (0, _bulkApplyRunTimeline.snapshotBulkApplyTimeline)(settledTimelineRun);
            timelineSnapshotAtMs = (0, _bulkApplyRunTimeline.bulkApplyClockMs)();
            void settleStepsAfterTheRunSettled({
              timeline: timelineAtCompletion,
              timelineRun: settledTimelineRun,
              timelineSnapshotAtMs: timelineSnapshotAtMs,
              settledGeneration: settledGeneration,
              settledRunKind: bulkRunOutcome.runKind,
              landingsAreAudited: landingsAreAudited,
              landingTargetsToAuditAtRunEnd: landingsAreAudited ? landingTargetsToAuditAtRunEndOf() : [],
              tableOfContentsIsRefreshed: tableOfContentsIsRefreshed,
              writtenPackageOoxmlsOfTheSettledRun: writtenPackageOoxmlsRef.current,
              onStepsAfterTheRunSettled: (_requestRef$current3 = requestRef.current) === null || _requestRef$current3 === void 0 ? void 0 : _requestRef$current3.onStepsAfterTheRunSettled
            });
            (_requestRef$current4 = requestRef.current) === null || _requestRef$current4 === void 0 || (_requestRef$current4$ = _requestRef$current4.onComplete) === null || _requestRef$current4$ === void 0 || _requestRef$current4$.call(_requestRef$current4, _objectSpread(_objectSpread({}, bulkRunOutcome), {}, {
              timeline: timelineAtCompletion,
              runDurationMs: Date.now() - runStartedAtMsRef.current
            }));
            /** The panel only closes itself on a clean sweep; any shortfall stays on screen so the user can read which rules still need them. */
            if (everyRuleApplied) setIsPanelOpen(false);
          case 7:
            return _context5.a(2);
        }
      }, _callee5, null, [[3, 5]]);
    }));
    return function tryComplete() {
      return _ref9.apply(this, arguments);
    };
  }();
  var settleStepsAfterTheRunSettled = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref13) {
      var timeline, timelineRun, timelineSnapshotAtMs, settledGeneration, settledRunKind, landingsAreAudited, landingTargetsToAuditAtRunEnd, tableOfContentsIsRefreshed, writtenPackageOoxmlsOfTheSettledRun, onStepsAfterTheRunSettled, stepSpans, timedAfterTheRun, finalTimeline;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            timeline = _ref13.timeline, timelineRun = _ref13.timelineRun, timelineSnapshotAtMs = _ref13.timelineSnapshotAtMs, settledGeneration = _ref13.settledGeneration, settledRunKind = _ref13.settledRunKind, landingsAreAudited = _ref13.landingsAreAudited, landingTargetsToAuditAtRunEnd = _ref13.landingTargetsToAuditAtRunEnd, tableOfContentsIsRefreshed = _ref13.tableOfContentsIsRefreshed, writtenPackageOoxmlsOfTheSettledRun = _ref13.writtenPackageOoxmlsOfTheSettledRun, onStepsAfterTheRunSettled = _ref13.onStepsAfterTheRunSettled;
            stepSpans = [];
            timedAfterTheRun = /*#__PURE__*/function () {
              var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(span, run) {
                var startedAtMs;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.p = _context6.n) {
                    case 0:
                      startedAtMs = (0, _bulkApplyRunTimeline.bulkApplyClockMs)();
                      _context6.p = 1;
                      _context6.n = 2;
                      return run();
                    case 2:
                      _context6.p = 2;
                      stepSpans.push({
                        span: span,
                        startedAtMs: timeline.runDurationMs + Math.round(startedAtMs - timelineSnapshotAtMs),
                        durationMs: Math.round((0, _bulkApplyRunTimeline.bulkApplyClockMs)() - startedAtMs)
                      });
                      return _context6.f(2);
                    case 3:
                      return _context6.a(2);
                  }
                }, _callee6, null, [[1,, 2, 3]]);
              }));
              return function timedAfterTheRun(_x9, _x0) {
                return _ref15.apply(this, arguments);
              };
            }();
            _context7.n = 1;
            return Promise.allSettled([landingsAreAudited ? timedAfterTheRun("landing_audit", function () {
              return auditLandingsAtRunEnd(landingTargetsToAuditAtRunEnd);
            }) : Promise.resolve(), tableOfContentsIsRefreshed ? timedAfterTheRun("table_of_contents_refresh", function () {
              return refreshTableOfContentsAfterBulkApply(writtenPackageOoxmlsOfTheSettledRun);
            }) : Promise.resolve()]);
          case 1:
            (0, _bulkApplyRunTimeline.finishBulkApplyTimeline)(timelineRun);
            finalTimeline = (0, _bulkApplyRunTimeline.bulkApplyTimelineOf)([].concat(_toConsumableArray(timeline.spans), stepSpans), timeline.runDurationMs + Math.round((0, _bulkApplyRunTimeline.bulkApplyClockMs)() - timelineSnapshotAtMs));
            try {
              if (settledGeneration === pollGenerationRef.current) (0, _bulkApplyRunTimeline.publishBulkApplyTimeline)(finalTimeline);
              (0, _sentryReporter.logInfo)(_bulkApplyRunTimeline.BULK_APPLY_TIMELINE_MESSAGE, {
                runKind: settledRunKind !== null && settledRunKind !== void 0 ? settledRunKind : "unknown",
                runDurationMs: finalTimeline.runDurationMs,
                spans: finalTimeline.spans.map(function (_ref16) {
                  var span = _ref16.span,
                    startedAtMs = _ref16.startedAtMs,
                    durationMs = _ref16.durationMs;
                  return "".concat(span, " @").concat(startedAtMs, " +").concat(durationMs);
                })
              });
            } finally {
              onStepsAfterTheRunSettled === null || onStepsAfterTheRunSettled === void 0 || onStepsAfterTheRunSettled(finalTimeline);
            }
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function settleStepsAfterTheRunSettled(_x8) {
      return _ref14.apply(this, arguments);
    };
  }();
  var handleApplyProgress = function handleApplyProgress(stepKey) {
    return function (progress) {
      lastProgressAtRef.current = Date.now();
      setApplyProgress(_objectSpread({
        stepKey: stepKey
      }, progress));
    };
  };
  var stepDetailsOf = function stepDetailsOf(stepKey, data, failedCount) {
    var ruleCount = collectRuleIds(data).length;
    if (ruleCount === 0) return "Nothing to apply";
    var doneVerb = stepKey === "adding_comments" ? "added" : "applied";
    return "".concat(ruleCount - failedCount, " of ").concat(ruleCount, " ").concat(doneVerb);
  };
  var stepStatusOf = function stepStatusOf(data, failedCount) {
    return failedCount > 0 && failedCount >= collectRuleIds(data).length ? "FAILED" : "COMPLETED";
  };
  var enqueueApply = function enqueueApply(stepKey, data, applyFn, errorMessage, actionName, stepLabel) {
    var step = stepsRef.current[stepKey];
    if (!step || step.applied) return;
    step.applied = true;
    (0, _sentryReporter.logInfo)(_bulkApplyPayloadStats.BULK_APPLY_PAYLOAD_MESSAGE, _objectSpread({
      step: stepLabel
    }, (0, _bulkApplyPayloadStats.bulkApplyPayloadStats)(data)));
    var queuedAtMs = (0, _bulkApplyRunTimeline.bulkApplyClockMs)();
    applyChainRef.current = applyChainRef.current.then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var failedCount, heldBackRuleIds, result, failedSet, failedEntries, attemptedData, _t4;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            (0, _bulkApplyRunTimeline.recordBulkApplySpan)("chain_wait_".concat(stepKey), queuedAtMs);
            markStep(stepKey, "IN_PROGRESS");
            failedCount = 0;
            heldBackRuleIds = [];
            _context8.p = 1;
            _context8.n = 2;
            return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("write_".concat(stepKey), function () {
              return applyData(data, applyFn, errorMessage, actionName);
            }, {
              entries: data.length
            });
          case 2:
            result = _context8.v;
            result.successfulRuleIds.forEach(function (id) {
              return accumulatedSuccessRef.current.add(id);
            });
            result.failedRuleIds.forEach(function (id) {
              return accumulatedFailedRef.current.add(id);
            });
            result.heldBackRuleIds.forEach(function (id) {
              return heldBackCommentRuleIdsRef.current.add(id);
            });
            heldBackRuleIds = result.heldBackRuleIds;
            recordStepOutcome(stepKey, result.successfulRuleIds, result.failedRuleIds);
            failedCount = result.failedRuleIds.length;
            if (failedCount > 0) {
              failedSet = new Set(result.failedRuleIds);
              failedEntries = data.flatMap(function (entry) {
                var _entry$rule_uuids3;
                return ((_entry$rule_uuids3 = entry.rule_uuids) !== null && _entry$rule_uuids3 !== void 0 ? _entry$rule_uuids3 : []).flatMap(function (uuid, index) {
                  var _entry$rule_names2;
                  return failedSet.has(uuid) ? [{
                    rule_uuids: [uuid],
                    rule_names: ((_entry$rule_names2 = entry.rule_names) === null || _entry$rule_names2 === void 0 ? void 0 : _entry$rule_names2[index]) === undefined ? [] : [entry.rule_names[index]]
                  }] : [];
                });
              });
              appendFailedRules(failedEntries);
            }
            _context8.n = 4;
            break;
          case 3:
            _context8.p = 3;
            _t4 = _context8.v;
            console.error("Error in enqueueApply(".concat(stepLabel, "):"), _t4);
            step.applied = false;
          case 4:
            step.completed = true;
            attemptedData = data.filter(function (entry) {
              var _entry$rule_uuids4;
              return ((_entry$rule_uuids4 = entry.rule_uuids) !== null && _entry$rule_uuids4 !== void 0 ? _entry$rule_uuids4 : []).some(function (ruleId) {
                return !heldBackRuleIds.includes(ruleId);
              });
            });
            markStep(stepKey, stepStatusOf(attemptedData, failedCount), stepDetailsOf(stepKey, attemptedData, failedCount));
            _context8.n = 5;
            return tryComplete();
          case 5:
            return _context8.a(2);
        }
      }, _callee8, null, [[1, 3]]);
    })));
  };

  /** WHEN the run cannot be carried any further: stops polling and settles on whatever the document already received. */
  var stopTheRunHere = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            runCannotContinueRef.current = true;
            _context9.n = 1;
            return tryComplete();
          case 1:
            return _context9.a(2);
        }
      }, _callee9);
    }));
    return function stopTheRunHere() {
      return _ref18.apply(this, arguments);
    };
  }();

  /** WHEN applying_comments reports FAILED, it owes its rules nothing more: settled as finished-but-unclean while the redline steps complete. */
  var settleTheCommentStepTheServerFailed = function settleTheCommentStepTheServerFailed(data) {
    var _data$applying_commen;
    if (((_data$applying_commen = data.applying_comments) === null || _data$applying_commen === void 0 ? void 0 : _data$applying_commen.status) !== "FAILED") return;
    hasServerFailedStepRef.current = true;
    var step = stepsRef.current.applying_comments;
    if (step) step.completed = true;
  };
  var applyMergeWithRepair = function applyMergeWithRepair(stepKey, origin) {
    return function (mergeEntries, sendErrorFn) {
      var _requestRef$current$i, _requestRef$current5, _requestRef$current$r3, _requestRef$current6;
      return applyBulkMerge({
        mergeData: mergeEntries,
        applySource: {
          initiatedFrom: (_requestRef$current$i = (_requestRef$current5 = requestRef.current) === null || _requestRef$current5 === void 0 ? void 0 : _requestRef$current5.initiatedFrom) !== null && _requestRef$current$i !== void 0 ? _requestRef$current$i : "bulk",
          reviewId: (_requestRef$current$r3 = (_requestRef$current6 = requestRef.current) === null || _requestRef$current6 === void 0 ? void 0 : _requestRef$current6.reviewId) !== null && _requestRef$current$r3 !== void 0 ? _requestRef$current$r3 : null
        },
        sendError: sendErrorFn,
        origin: origin,
        onRepairing: setIsRepairing,
        onProgress: handleApplyProgress(stepKey)
      });
    };
  };

  /**
   * Writes each card through the applier, one by one.
   *
   * CASES, per card
   *   - the applier wrote it                              -> credited
   *   - the applier wrote part of it (`PartialRedlineApply`) -> credited and partly applied: what landed
   *                                                          stays, the card carries the applier's
   *                                                          reason, and the run-end audit leaves it alone
   *   - the applier threw anything else                   -> its rules fail, the card is dropped with the reason
   *
   * WHY a partly applied card is credited and not dropped
   *   The applier never takes back what it wrote, so the document holds part of the card;
   *   dropped, the card read "Failed to apply" with its cells in the document and stayed
   *   selected for a run that would write them again (reviewer -3a at aeee2a0c3). Credited
   *   and marked partly applied, it says so and is not selected again, as the single Apply
   *   path marks it since 65680fd31.
   */
  var applyCardsOneByOne = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(cards, failureReasonOf) {
      var applier, failedRuleIds, _iterator, _step, _loop, _t6;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            applier = new _proposalApplier.ProposalApplier(_anchorTrackerRegistry.anchorTrackers, _recoveryConfig.DEFAULT_RECOVERY_CONFIG);
            failedRuleIds = [];
            _iterator = _createForOfIteratorHelper(cards);
            _context1.p = 1;
            _loop = /*#__PURE__*/_regenerator().m(function _loop() {
              var entry, writtenOutcome, _t5;
              return _regenerator().w(function (_context0) {
                while (1) switch (_context0.p = _context0.n) {
                  case 0:
                    entry = _step.value;
                    _context0.p = 1;
                    _context0.n = 2;
                    return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("card_applier_write", function () {
                      return applier.applyOnBookmarks({
                        bookmarkNames: entry.target_bookmark_names,
                        redline: (0, _redlinePayload.textsPayloadFrom)(entry.card),
                        cardId: entry.rule_uuids.join(","),
                        pageOfTheRun: entry.pageOfTheRun
                      });
                    });
                  case 2:
                    writtenOutcome = _context0.v;
                    writtenPackageOoxmlsRef.current = [].concat(_toConsumableArray(writtenPackageOoxmlsRef.current), _toConsumableArray(writtenOutcome.writtenPackageOoxmls));
                    _context0.n = 5;
                    break;
                  case 3:
                    _context0.p = 3;
                    _t5 = _context0.v;
                    if (!(_t5 instanceof _errors.PartialRedlineApply)) {
                      _context0.n = 4;
                      break;
                    }
                    partiallyAppliedRuleIdsRef.current = [].concat(_toConsumableArray(partiallyAppliedRuleIdsRef.current), _toConsumableArray(entry.rule_uuids));
                    partiallyAppliedCardsRef.current = [].concat(_toConsumableArray(partiallyAppliedCardsRef.current), _toConsumableArray(entry.rule_uuids.map(function (ruleId) {
                      return {
                        ruleId: ruleId,
                        reason: _t5.message,
                        conflictingRuleIds: [],
                        everyWriteLanded: _t5.everyWriteLanded,
                        writtenBack: _t5 instanceof _errors.WrittenBackRedlineApply
                      };
                    })));
                    return _context0.a(2, 1);
                  case 4:
                    failedRuleIds.push.apply(failedRuleIds, _toConsumableArray(entry.rule_uuids));
                    droppedCardsRef.current = [].concat(_toConsumableArray(droppedCardsRef.current), _toConsumableArray(entry.rule_uuids.map(function (ruleId) {
                      return {
                        ruleId: ruleId,
                        reason: failureReasonOf(_t5),
                        conflictingRuleIds: []
                      };
                    })));
                  case 5:
                    return _context0.a(2);
                }
              }, _loop, null, [[1, 3]]);
            });
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context1.n = 5;
              break;
            }
            return _context1.d(_regeneratorValues(_loop()), 3);
          case 3:
            if (!_context1.v) {
              _context1.n = 4;
              break;
            }
            return _context1.a(3, 4);
          case 4:
            _context1.n = 2;
            break;
          case 5:
            _context1.n = 7;
            break;
          case 6:
            _context1.p = 6;
            _t6 = _context1.v;
            _iterator.e(_t6);
          case 7:
            _context1.p = 7;
            _iterator.f();
            return _context1.f(7);
          case 8:
            return _context1.a(2, {
              failedRuleIds: failedRuleIds
            });
        }
      }, _callee0, null, [[1, 6, 7, 8]]);
    }));
    return function applyCardsOneByOne(_x1, _x10) {
      return _ref19.apply(this, arguments);
    };
  }();

  /**
   * The table cards of a local run, written one by one through the applier: the one
   * writer that edits a cell paragraph in place and writes rows and tables through
   * Word's table API. A card the applier refuses fails its rule alone.
   */
  var applyTableCards = function applyTableCards(cards) {
    return applyCardsOneByOne(cards, function (error) {
      return "Word could not write this table change: ".concat(error instanceof Error ? error.message : String(error));
    });
  };
  var recordWrittenTargets = function recordWrittenTargets(stepKey, targets, writeFailedRuleIds) {
    var writeFailed = new Set(writeFailedRuleIds);
    writtenLandingTargetsRef.current = [].concat(_toConsumableArray(writtenLandingTargetsRef.current), _toConsumableArray(targets.filter(function (target) {
      return !writeFailed.has(target.ruleId);
    }).map(function (target) {
      return {
        stepKey: stepKey,
        target: target
      };
    })));
    return {
      failedRuleIds: writeFailedRuleIds
    };
  };

  /**
   * Reads every card and comment the run wrote against the document, once, at the end.
   * One that reads differently is logged, never relabelled (`logLandingMismatches`).
   */
  var landingTargetsToAuditAtRunEndOf = function landingTargetsToAuditAtRunEndOf() {
    var alreadyFailed = new Set([].concat(_toConsumableArray(accumulatedFailedRef.current), _toConsumableArray(droppedCardsRef.current.map(function (dropped) {
      return dropped.ruleId;
    })), _toConsumableArray(notChosenRuleIdsRef.current), _toConsumableArray(partiallyAppliedRuleIdsRef.current)));
    return writtenLandingTargetsRef.current.filter(function (_ref20) {
      var target = _ref20.target;
      return !alreadyFailed.has(target.ruleId);
    }).map(function (_ref21) {
      var target = _ref21.target;
      return target;
    });
  };
  var auditLandingsAtRunEnd = /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(judgedTargets) {
      var verdicts, _t7, _t8;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            _t7 = judgedTargets.length === 0;
            if (_t7) {
              _context10.n = 2;
              break;
            }
            _context10.n = 1;
            return _proposalEngineAccess.ProposalEngineAccess.current();
          case 1:
            _t7 = !_context10.v.enabled;
          case 2:
            if (!_t7) {
              _context10.n = 3;
              break;
            }
            return _context10.a(2);
          case 3:
            _context10.p = 3;
            _context10.n = 4;
            return (0, _redlineLandingReconciliation.auditCardLandings)(judgedTargets, _redlineLandingPageFacts.readLandingPageFacts);
          case 4:
            verdicts = _context10.v;
            (0, _redlineLandingReconciliation.logLandingMismatches)(verdicts, judgedTargets);
            _context10.n = 6;
            break;
          case 5:
            _context10.p = 5;
            _t8 = _context10.v;
            sendError(_t8 instanceof Error ? _t8 : new Error(String(_t8)), {
              component: "BulkApplyRunProvider",
              action: "audit_landings"
            });
          case 6:
            return _context10.a(2);
        }
      }, _callee1, null, [[3, 5]]);
    }));
    return function auditLandingsAtRunEnd(_x11) {
      return _ref22.apply(this, arguments);
    };
  }();
  var landingTargetOfRemedy = function landingTargetOfRemedy(remedy) {
    return remedy.target_texts === null ? {
      kind: "markup",
      ruleId: remedy.rule_uuid,
      bookmarkNames: remedy.target_bookmark_names,
      packageOoxmls: remedy.target_ooxml_after,
      insertsAfterBookmarks: false
    } : {
      kind: "text_card",
      ruleId: remedy.rule_uuid,
      bookmarkNames: remedy.target_bookmark_names,
      card: remedy.target_texts,
      insertsAfterBookmarks: false
    };
  };
  var landingTargetAsWrittenOf = function landingTargetAsWrittenOf(remedy) {
    var asWritten = cardsAsWrittenRef.current.find(function (cardAsWritten) {
      return cardAsWritten.ruleId === remedy.rule_uuid;
    });
    return asWritten === undefined ? landingTargetOfRemedy(remedy) : {
      kind: "text_card",
      ruleId: remedy.rule_uuid,
      bookmarkNames: remedy.target_bookmark_names,
      card: asWritten.card,
      insertsAfterBookmarks: false
    };
  };
  var commentTargetsOf = function commentTargetsOf(entries) {
    return entries.flatMap(function (entry) {
      var _entry$rule_uuids5;
      return ((_entry$rule_uuids5 = entry.rule_uuids) !== null && _entry$rule_uuids5 !== void 0 ? _entry$rule_uuids5 : []).map(function (ruleId) {
        var _entry$issue_comment_, _entry$anchor_text;
        return {
          kind: "comment",
          ruleId: ruleId,
          bookmarkNames: entry.target_bookmark_names,
          commentText: entry.comment_text,
          issueCommentId: (_entry$issue_comment_ = entry.issue_comment_id) !== null && _entry$issue_comment_ !== void 0 ? _entry$issue_comment_ : null,
          quotedText: (_entry$anchor_text = entry.anchor_text) !== null && _entry$anchor_text !== void 0 ? _entry$anchor_text : null
        };
      });
    });
  };
  var applyMergeThenRecord = function applyMergeThenRecord(input) {
    return /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(mergeEntries, sendErrorFn) {
        var merged, writtenRuleIds, writtenRemedies;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              bodyReadOfTheMergesRef.current = null;
              _context11.n = 1;
              return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("merge_write", function () {
                return applyMergeWithRepair("applying_redlines", "engine")(mergeEntries, sendErrorFn);
              }, {
                entries: mergeEntries.length
              });
            case 1:
              merged = _context11.v;
              bodyReadOfTheMergesRef.current = merged.bodyRead;
              mergeWritesRef.current = [].concat(_toConsumableArray(mergeWritesRef.current), [merged.mergeWrite]);
              writtenPackageOoxmlsRef.current = [].concat(_toConsumableArray(writtenPackageOoxmlsRef.current), _toConsumableArray(mergeEntries.flatMap(function (entry) {
                return entry.target_ooxml_after;
              })));
              writtenRuleIds = new Set(mergeEntries.flatMap(function (entry) {
                var _entry$rule_uuids6;
                return (_entry$rule_uuids6 = entry.rule_uuids) !== null && _entry$rule_uuids6 !== void 0 ? _entry$rule_uuids6 : [];
              }));
              creditFoldPartlyAppliedCards(writtenRuleIds, merged.failedRuleIds);
              writtenRemedies = input.remedies.filter(function (remedy) {
                return remedy.target_texts !== null && writtenRuleIds.has(remedy.rule_uuid);
              });
              return _context11.a(2, recordWrittenTargets("applying_redlines", writtenRemedies.map(landingTargetAsWrittenOf), merged.failedRuleIds));
          }
        }, _callee10);
      }));
      return function (_x12, _x13) {
        return _ref23.apply(this, arguments);
      };
    }();
  };
  var creditFoldPartlyAppliedCards = function creditFoldPartlyAppliedCards(writtenRuleIds, failedRuleIds) {
    var landedPartlyAppliedCards = foldPartlyAppliedCardsRef.current.filter(function (card) {
      return writtenRuleIds.has(card.ruleId) && !failedRuleIds.includes(card.ruleId) && !partiallyAppliedRuleIdsRef.current.includes(card.ruleId);
    });
    partiallyAppliedRuleIdsRef.current = [].concat(_toConsumableArray(partiallyAppliedRuleIdsRef.current), _toConsumableArray(landedPartlyAppliedCards.map(function (card) {
      return card.ruleId;
    })));
    partiallyAppliedCardsRef.current = [].concat(_toConsumableArray(partiallyAppliedCardsRef.current), _toConsumableArray(landedPartlyAppliedCards));
  };
  var tableCardTargetsAsProposedOf = function tableCardTargetsAsProposedOf(entries, input) {
    return entries.flatMap(function (entry) {
      return entry.rule_uuids.map(function (ruleId) {
        var _ref24, _cardsAsWrittenRef$cu, _cardsAsWrittenRef$cu2, _remedy$target_bookma;
        var remedy = input.remedies.find(function (candidate) {
          return candidate.rule_uuid === ruleId;
        });
        var cardOfRule = (_ref24 = (_cardsAsWrittenRef$cu = (_cardsAsWrittenRef$cu2 = cardsAsWrittenRef.current.find(function (cardAsWritten) {
          return cardAsWritten.ruleId === ruleId;
        })) === null || _cardsAsWrittenRef$cu2 === void 0 ? void 0 : _cardsAsWrittenRef$cu2.card) !== null && _cardsAsWrittenRef$cu !== void 0 ? _cardsAsWrittenRef$cu : remedy === null || remedy === void 0 ? void 0 : remedy.target_texts) !== null && _ref24 !== void 0 ? _ref24 : entry.card;
        var card = entry.rule_uuids.length === 1 ? _objectSpread(_objectSpread({}, cardOfRule), {}, {
          tableChanges: entry.card.tableChanges
        }) : cardOfRule;
        return {
          kind: "text_card",
          ruleId: ruleId,
          bookmarkNames: (_remedy$target_bookma = remedy === null || remedy === void 0 ? void 0 : remedy.target_bookmark_names) !== null && _remedy$target_bookma !== void 0 ? _remedy$target_bookma : entry.target_bookmark_names,
          card: card,
          insertsAfterBookmarks: false
        };
      });
    });
  };
  var applyTableCardsThenRecord = function applyTableCardsThenRecord(input) {
    return /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(cards) {
        var reportSlotFailure, slotCardIdOfFoldedEntry, inTheirSlots, failedRuleIds, _iterator2, _step2, entry, _yield$placeTableCard, _yield$placeTableCard2, cardAfterTablesWrittenBeforeIt, entryInItsSlot, written, _t9;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              reportSlotFailure = function reportSlotFailure(cardId, failure) {
                return sendError(failure instanceof Error ? failure : new Error(String(failure)), {
                  component: "BulkApplyRunProvider",
                  action: "place_tables_in_slots",
                  cardId: cardId
                });
              };
              slotCardIdOfFoldedEntry = function slotCardIdOfFoldedEntry(entry) {
                var _entry$rule_uuids$fin;
                return (_entry$rule_uuids$fin = entry.rule_uuids.find(function (ruleId) {
                  return slotInsertionsSharedWithTableStepRef.current.some(function (slotInsertion) {
                    return slotInsertion.cardId === ruleId;
                  });
                })) !== null && _entry$rule_uuids$fin !== void 0 ? _entry$rule_uuids$fin : entry.rule_uuids[0];
              };
              inTheirSlots = [];
              failedRuleIds = [];
              if (cards.length > 0) bodyReadOfTheMergesRef.current = null;
              _iterator2 = _createForOfIteratorHelper(cards);
              _context12.p = 1;
              _iterator2.s();
            case 2:
              if ((_step2 = _iterator2.n()).done) {
                _context12.n = 6;
                break;
              }
              entry = _step2.value;
              _context12.n = 3;
              return (0, _redlineInsertionSlot.placeTableCardsInSlots)([{
                cardId: slotCardIdOfFoldedEntry(entry),
                card: entry.card
              }], slotInsertionsSharedWithTableStepRef.current, _redlineInsertionSlot.officeSlotPage, reportSlotFailure);
            case 3:
              _yield$placeTableCard = _context12.v;
              _yield$placeTableCard2 = _slicedToArray(_yield$placeTableCard, 1);
              cardAfterTablesWrittenBeforeIt = _yield$placeTableCard2[0];
              entryInItsSlot = _objectSpread(_objectSpread({}, entry), {}, {
                card: cardAfterTablesWrittenBeforeIt
              });
              inTheirSlots.push(entryInItsSlot);
              _context12.n = 4;
              return applyTableCards([entryInItsSlot]);
            case 4:
              written = _context12.v;
              creditFoldPartlyAppliedCards(new Set(entry.rule_uuids), written.failedRuleIds);
              failedRuleIds.push.apply(failedRuleIds, _toConsumableArray(written.failedRuleIds));
            case 5:
              _context12.n = 2;
              break;
            case 6:
              _context12.n = 8;
              break;
            case 7:
              _context12.p = 7;
              _t9 = _context12.v;
              _iterator2.e(_t9);
            case 8:
              _context12.p = 8;
              _iterator2.f();
              return _context12.f(8);
            case 9:
              return _context12.a(2, recordWrittenTargets("applying_table_changes", tableCardTargetsAsProposedOf(inTheirSlots, input), failedRuleIds));
          }
        }, _callee11, null, [[1, 7, 8, 9]]);
      }));
      return function (_x14) {
        return _ref25.apply(this, arguments);
      };
    }();
  };
  var applyRedlinesThenRecord = function applyRedlinesThenRecord(input) {
    return /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(entries, sendErrorFn) {
        var mergeEntries, merged, besideParagraphCards, written, placed;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              mergeEntries = entries.filter(isMergeEntry);
              _context13.n = 1;
              return applyMergeThenRecord(input)(mergeEntries, sendErrorFn).catch(function (error) {
                sendErrorFn(error, {
                  component: "BulkApplyRunProvider",
                  action: "apply_merge_data",
                  data: mergeEntries
                });
                return {
                  failedRuleIds: collectRuleIds(mergeEntries)
                };
              });
            case 1:
              merged = _context13.v;
              besideParagraphCards = entries.filter(isCardForTheApplier);
              if (besideParagraphCards.length > 0) bodyReadOfTheMergesRef.current = null;
              _context13.n = 2;
              return applyCardsOneByOne(besideParagraphCards, _errors.userMessageOf);
            case 2:
              written = _context13.v;
              placed = recordWrittenTargets("applying_redlines", textCardTargetsOf(besideParagraphCards), written.failedRuleIds);
              return _context13.a(2, {
                failedRuleIds: [].concat(_toConsumableArray(merged.failedRuleIds), _toConsumableArray(placed.failedRuleIds))
              });
          }
        }, _callee12);
      }));
      return function (_x15, _x16) {
        return _ref26.apply(this, arguments);
      };
    }();
  };
  var ruleIdsWhoseCardsDidNotLand = function ruleIdsWhoseCardsDidNotLand() {
    return new Set([].concat(_toConsumableArray(accumulatedFailedRef.current), _toConsumableArray(droppedCardsRef.current.map(function (dropped) {
      return dropped.ruleId;
    })), _toConsumableArray(notChosenRuleIdsRef.current)));
  };
  var sitsOnANewParagraphThatDidNotLand = function sitsOnANewParagraphThatDidNotLand(entry, ruleIdsNotLanded) {
    var _entry$rule_uuids7;
    return entry.placement === "after_paragraph" && ((_entry$rule_uuids7 = entry.rule_uuids) !== null && _entry$rule_uuids7 !== void 0 ? _entry$rule_uuids7 : []).some(function (ruleId) {
      return ruleIdsNotLanded.has(ruleId);
    });
  };
  var waitsForACardThatDidNotLand = function waitsForACardThatDidNotLand(entry, ruleIdsNotLanded) {
    return entry.waits_for_rule_uuid !== undefined && entry.waits_for_rule_uuid !== null && ruleIdsNotLanded.has(entry.waits_for_rule_uuid);
  };
  var commentEntriesHeldBack = /*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(entries) {
      var watchedPage, commentContents, recoveryFoundNothingFor, ruleIdsNotLanded;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.n) {
          case 0:
            watchedPage = (0, _pageRevisions.livePageSnapshotOf)(_anchorTrackerRegistry.documentPages.page);
            commentContents = entries.map(_commentTargetRecovery.commentContentOfBulkEntry);
            _context14.n = 1;
            return (0, _commentTargetRecovery.recoverCommentTargetsForApply)(commentContents);
          case 1:
            recoveryFoundNothingFor = _context14.v;
            ruleIdsNotLanded = ruleIdsWhoseCardsDidNotLand();
            return _context14.a(2, entries.flatMap(function (entry, entryIndex) {
              if (sitsOnANewParagraphThatDidNotLand(entry, ruleIdsNotLanded) || waitsForACardThatDidNotLand(entry, ruleIdsNotLanded)) return [{
                entry: entry,
                heldBackReason: COMMENT_NOT_ADDED_REDLINE_NOT_APPLIED
              }];
              var paragraphIsGone = recoveryFoundNothingFor.has(commentContents[entryIndex]) || (0, _cardTargetState.commentTargetStateOf)(commentContents[entryIndex].bookmarks, watchedPage, false) !== null;
              return paragraphIsGone ? [{
                entry: entry,
                heldBackReason: COMMENT_NOT_ADDED_PARAGRAPH_GONE
              }] : [];
            }));
        }
      }, _callee13);
    }));
    return function commentEntriesHeldBack(_x17) {
      return _ref27.apply(this, arguments);
    };
  }();
  var proposalEngineWritesTheRunsComments = /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
      var _t0;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.n) {
          case 0:
            _t0 = runKindRef.current === "local";
            if (!_t0) {
              _context15.n = 2;
              break;
            }
            _context15.n = 1;
            return _proposalEngineAccess.ProposalEngineAccess.current();
          case 1:
            _t0 = _context15.v.enabled;
          case 2:
            return _context15.a(2, _t0);
        }
      }, _callee14);
    }));
    return function proposalEngineWritesTheRunsComments() {
      return _ref28.apply(this, arguments);
    };
  }();
  var applyCommentsThenRecord = function applyCommentsThenRecord(stepKey) {
    return /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(entries, sendErrorFn) {
        var writtenAsMainWritesThem, heldBackComments, heldBackEntries, entriesToWrite, written, failureOfEntry, relocationOfEntry, writtenCommentTargets, ruleIdsWritten;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _context16.n = 1;
              return proposalEngineWritesTheRunsComments();
            case 1:
              if (_context16.v) {
                _context16.n = 3;
                break;
              }
              _context16.n = 2;
              return (0, _document.applyBulkCommentData)(entries, sendErrorFn, {
                onProgress: handleApplyProgress(stepKey)
              });
            case 2:
              writtenAsMainWritesThem = _context16.v;
              return _context16.a(2, recordWrittenTargets(stepKey, commentTargetsOf(entries), writtenAsMainWritesThem.failedRuleIds));
            case 3:
              _context16.n = 4;
              return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("comment_entries_held_back", function () {
                return commentEntriesHeldBack(entries);
              }, {
                entries: entries.length
              });
            case 4:
              heldBackComments = _context16.v;
              heldBackComments.forEach(function (_ref30) {
                var entry = _ref30.entry,
                  heldBackReason = _ref30.heldBackReason;
                return recordCommentOutcomes(entry, "heldBack", null, null, heldBackReason);
              });
              heldBackEntries = heldBackComments.map(function (_ref31) {
                var entry = _ref31.entry;
                return entry;
              });
              entriesToWrite = entries.filter(function (entry) {
                return !heldBackEntries.includes(entry);
              });
              _context16.n = 5;
              return (0, _document.applyBulkCommentData)(entriesToWrite, sendErrorFn, {
                onProgress: handleApplyProgress(stepKey),
                triesEveryComment: true,
                bodyReadOfTheMerges: bodyReadOfTheMergesRef.current
              });
            case 5:
              written = _context16.v;
              failureOfEntry = new Map(written.commentEntryFailures.map(function (commentEntryFailure) {
                return [commentEntryFailure.commentEntry, commentEntryFailure];
              }));
              relocationOfEntry = new Map(written.commentEntryRelocations.map(function (commentEntryRelocation) {
                return [commentEntryRelocation.commentEntry, commentEntryRelocation];
              }));
              writtenCommentTargets = entriesToWrite.flatMap(function (entry) {
                var _failureOfEntry$get, _relocationOfEntry$ge;
                var commentEntryFailure = (_failureOfEntry$get = failureOfEntry.get(entry)) !== null && _failureOfEntry$get !== void 0 ? _failureOfEntry$get : null;
                return recordCommentOutcomes(entry, commentEntryFailure === null ? "written" : "failed", commentEntryFailure, (_relocationOfEntry$ge = relocationOfEntry.get(entry)) !== null && _relocationOfEntry$ge !== void 0 ? _relocationOfEntry$ge : null);
              });
              ruleIdsWritten = new Set(collectRuleIds(entriesToWrite));
              return _context16.a(2, _objectSpread(_objectSpread({}, recordWrittenTargets(stepKey, writtenCommentTargets, written.failedRuleIds)), {}, {
                heldBackRuleIds: collectRuleIds(heldBackEntries).filter(function (ruleId) {
                  return !ruleIdsWritten.has(ruleId);
                })
              }));
          }
        }, _callee15);
      }));
      return function (_x18, _x19) {
        return _ref29.apply(this, arguments);
      };
    }();
  };
  var recordCommentOutcomes = function recordCommentOutcomes(entry, result, failureCause, relocation, heldBackReason) {
    var landingTargets = commentTargetsOf([entry]);
    landingTargets.forEach(function (landingTarget) {
      var _entry$issue_comment_2, _failureCause$failure, _failureCause$failure2;
      var commentOutcome = _objectSpread({
        ruleId: landingTarget.ruleId,
        issueCommentId: (_entry$issue_comment_2 = entry.issue_comment_id) !== null && _entry$issue_comment_2 !== void 0 ? _entry$issue_comment_2 : null,
        result: result,
        failureReason: (_failureCause$failure = failureCause === null || failureCause === void 0 ? void 0 : failureCause.failureReason) !== null && _failureCause$failure !== void 0 ? _failureCause$failure : null,
        failureMessage: (_failureCause$failure2 = failureCause === null || failureCause === void 0 ? void 0 : failureCause.failureMessage) !== null && _failureCause$failure2 !== void 0 ? _failureCause$failure2 : null,
        relocation: relocation
      }, heldBackReason === undefined ? {} : {
        heldBackReason: heldBackReason
      });
      commentOutcomesRef.current = [].concat(_toConsumableArray(commentOutcomesRef.current), [commentOutcome]);
    });
    if (result === "failed") {
      var paragraphGone = (failureCause === null || failureCause === void 0 ? void 0 : failureCause.failureReason) === _appliedActions.APPLY_FAILURE_LOCATION_NOT_FOUND;
      commentsNotWrittenRef.current = [].concat(_toConsumableArray(commentsNotWrittenRef.current), _toConsumableArray(landingTargets.flatMap(function (landingTarget) {
        return landingTarget.kind === "comment" ? [{
          target: landingTarget,
          paragraphGone: paragraphGone
        }] : [];
      })));
    }
    return result === "written" ? landingTargets : [];
  };
  var applyPipelineMergeThenRecord = function applyPipelineMergeThenRecord(stepKey) {
    return /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(mergeEntries, sendErrorFn) {
        var merged, writtenRuleIds, writtenRemedies;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _context17.n = 1;
              return applyMergeWithRepair(stepKey, "pipeline")(mergeEntries, sendErrorFn);
            case 1:
              merged = _context17.v;
              mergeWritesRef.current = [].concat(_toConsumableArray(mergeWritesRef.current), [merged.mergeWrite]);
              writtenRuleIds = new Set(collectRuleIds(mergeEntries));
              writtenRemedies = pipelineRemediesRef.current.filter(function (remedy) {
                return writtenRuleIds.has(remedy.rule_uuid);
              });
              return _context17.a(2, recordWrittenTargets(stepKey, writtenRemedies.map(landingTargetOfRemedy), merged.failedRuleIds));
          }
        }, _callee16);
      }));
      return function (_x20, _x21) {
        return _ref32.apply(this, arguments);
      };
    }();
  };
  var ruleNameOf = function ruleNameOf(ruleId) {
    var _requestRef$current$r4, _requestRef$current7;
    return (_requestRef$current$r4 = (_requestRef$current7 = requestRef.current) === null || _requestRef$current7 === void 0 || (_requestRef$current7 = _requestRef$current7.rules.find(function (rule) {
      return rule.ruleId === ruleId;
    })) === null || _requestRef$current7 === void 0 ? void 0 : _requestRef$current7.ruleName) !== null && _requestRef$current$r4 !== void 0 ? _requestRef$current$r4 : ruleId;
  };
  var ruleEntryOf = function ruleEntryOf(ruleId) {
    return {
      rule_uuids: [ruleId],
      rule_names: [ruleNameOf(ruleId)]
    };
  };
  var recordFold = function recordFold(entries, remediesOfTheRun) {
    droppedCardsRef.current = [].concat(_toConsumableArray(droppedCardsRef.current), _toConsumableArray(entries.droppedCards));
    notChosenRuleIdsRef.current = [].concat(_toConsumableArray(notChosenRuleIdsRef.current), _toConsumableArray(entries.notChosenCards.map(function (card) {
      return card.ruleId;
    })));
    notChosenCardsRef.current = [].concat(_toConsumableArray(notChosenCardsRef.current), _toConsumableArray(entries.notChosenCards));
    partlySupersededCardsRef.current = [].concat(_toConsumableArray(partlySupersededCardsRef.current), _toConsumableArray(entries.partlySupersededCards));
    cardsAsWrittenRef.current = [].concat(_toConsumableArray(cardsAsWrittenRef.current), _toConsumableArray(entries.cardsAsWritten));
    foldPartlyAppliedCardsRef.current = [].concat(_toConsumableArray(foldPartlyAppliedCardsRef.current), _toConsumableArray(entries.partlyAppliedCards));
    entries.alreadyAppliedRuleIds.forEach(function (ruleId) {
      return accumulatedSuccessRef.current.add(ruleId);
    });
    recordStepOutcome("applying_redlines", entries.alreadyAppliedRuleIds, []);
    setFailedCardDetails((0, _redlineBulkApplyLocal.failedCardDetailsOf)(remediesOfTheRun, droppedCardsRef.current));
    recordFailedRules(entries.droppedCards.map(function (dropped) {
      return ruleEntryOf(dropped.ruleId);
    }));
  };
  var recordCardsNotFound = function recordCardsNotFound(notFoundCards, remediesOfTheRun) {
    droppedCardsRef.current = [].concat(_toConsumableArray(droppedCardsRef.current), _toConsumableArray(notFoundCards));
    setFailedCardDetails((0, _redlineBulkApplyLocal.failedCardDetailsOf)(remediesOfTheRun, droppedCardsRef.current));
    recordFailedRules(notFoundCards.map(function (dropped) {
      return ruleEntryOf(dropped.ruleId);
    }));
  };
  var foldCardsTheServerFinds = /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(leftForTheServer, placedInput) {
      var _serverPass, notFoundCards, notFoundRuleIds, foundInput, entries, alreadyRecorded, _t1;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.p = _context18.n) {
          case 0:
            _context18.p = 0;
            _context18.n = 1;
            return serverPassOf(leftForTheServer);
          case 1:
            _serverPass = _context18.v;
            notFoundCards = _serverPass.notFoundByTheServer.map(function (remedy) {
              return {
                ruleId: remedy.rule_uuid,
                reason: _errors.CANNOT_LOCATE_TARGET_MESSAGE,
                conflictingRuleIds: []
              };
            });
            recordCardsNotFound(notFoundCards, placedInput.remedies);
            notFoundRuleIds = notFoundCards.map(function (card) {
              return card.ruleId;
            });
            if (!(_serverPass.laidOnTheirParagraphs.length === 0 && _serverPass.placedBesideParagraphs.length === 0)) {
              _context18.n = 2;
              break;
            }
            return _context18.a(2, {
              cardsTheServerFound: null,
              failedRuleIds: notFoundRuleIds
            });
          case 2:
            foundInput = _objectSpread(_objectSpread({}, placedInput), {}, {
              remedies: _serverPass.laidOnTheirParagraphs,
              remediesPlacedBesideParagraphs: _serverPass.placedBesideParagraphs,
              comments: [],
              documentPagesOfTheRun: _serverPass.documentPages
            });
            _context18.n = 3;
            return (0, _redlineBulkApplyLocal.localBulkApplyEntries)(foundInput, {
              stepStarted: function stepStarted() {
                return undefined;
              },
              stepFinished: function stepFinished() {
                return undefined;
              }
            });
          case 3:
            entries = _context18.v;
            recordFold(entries, placedInput.remedies);
            return _context18.a(2, {
              cardsTheServerFound: {
                foundInput: foundInput,
                entries: entries
              },
              failedRuleIds: [].concat(_toConsumableArray(notFoundRuleIds), _toConsumableArray(entries.droppedCards.map(function (card) {
                return card.ruleId;
              })))
            });
          case 4:
            _context18.p = 4;
            _t1 = _context18.v;
            sendError(_t1 instanceof Error ? _t1 : new Error(String(_t1)), {
              component: "BulkApplyRunProvider",
              action: "find_moved_changes"
            });
            alreadyRecorded = new Set(droppedCardsRef.current.map(function (card) {
              return card.ruleId;
            }));
            recordCardsNotFound(leftForTheServer.filter(function (remedy) {
              return !alreadyRecorded.has(remedy.rule_uuid);
            }).map(function (remedy) {
              return {
                ruleId: remedy.rule_uuid,
                reason: (0, _errors.userMessageOf)(_t1),
                conflictingRuleIds: []
              };
            }), placedInput.remedies);
            return _context18.a(2, {
              cardsTheServerFound: null,
              failedRuleIds: leftForTheServer.map(function (remedy) {
                return remedy.rule_uuid;
              })
            });
        }
      }, _callee17, null, [[0, 4]]);
    }));
    return function foldCardsTheServerFinds(_x22, _x23) {
      return _ref33.apply(this, arguments);
    };
  }();
  var writeCardsTheServerFinds = /*#__PURE__*/function () {
    var _ref34 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(leftForTheServer, placedInput) {
      var _yield$foldCardsTheSe, cardsTheServerFound, failedRuleIds, foundInput, entries, redlinesWritten, tablesWritten;
      return _regenerator().w(function (_context19) {
        while (1) switch (_context19.n) {
          case 0:
            if (!(leftForTheServer.length === 0)) {
              _context19.n = 1;
              break;
            }
            return _context19.a(2, []);
          case 1:
            _context19.n = 2;
            return foldCardsTheServerFinds(leftForTheServer, placedInput);
          case 2:
            _yield$foldCardsTheSe = _context19.v;
            cardsTheServerFound = _yield$foldCardsTheSe.cardsTheServerFound;
            failedRuleIds = _yield$foldCardsTheSe.failedRuleIds;
            if (!(cardsTheServerFound === null)) {
              _context19.n = 3;
              break;
            }
            return _context19.a(2, failedRuleIds);
          case 3:
            foundInput = cardsTheServerFound.foundInput, entries = cardsTheServerFound.entries;
            _context19.n = 4;
            return applyData([].concat(_toConsumableArray(entries.mergeData), _toConsumableArray(entries.besideParagraphCards)), applyRedlinesThenRecord(foundInput), "We had an error applying the changes.", "apply_moved_merge_data");
          case 4:
            redlinesWritten = _context19.v;
            _context19.n = 5;
            return applyData(entries.tableCards, applyTableCardsThenRecord(foundInput), "We had an error applying the table changes.", "apply_moved_table_cards");
          case 5:
            tablesWritten = _context19.v;
            return _context19.a(2, [].concat(_toConsumableArray(failedRuleIds), _toConsumableArray(redlinesWritten.failedRuleIds), _toConsumableArray(tablesWritten.failedRuleIds)));
        }
      }, _callee18);
    }));
    return function writeCardsTheServerFinds(_x24, _x25) {
      return _ref34.apply(this, arguments);
    };
  }();
  var enqueueServerPass = function enqueueServerPass(leftForTheServer, placedInput) {
    var step = stepsRef.current.finding_moved_changes;
    if (!step || step.applied) return;
    step.applied = true;
    var leftEntries = leftForTheServer.map(function (remedy) {
      return {
        rule_uuids: [remedy.rule_uuid],
        rule_names: [remedy.rule_name]
      };
    });
    applyChainRef.current = applyChainRef.current.then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
      var failedRuleIds, succeededRuleIds, _t10, _t11, _t12;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.n) {
          case 0:
            markStep("finding_moved_changes", "IN_PROGRESS", leftForTheServer.length === 0 ? null : "Looking for ".concat(leftForTheServer.length, " of the changes"));
            _t10 = Array;
            _t11 = Set;
            _context20.n = 1;
            return writeCardsTheServerFinds(leftForTheServer, placedInput);
          case 1:
            _t12 = _context20.v;
            failedRuleIds = _t10.from.call(_t10, new _t11(_t12));
            succeededRuleIds = collectRuleIds(leftEntries).filter(function (ruleId) {
              return !failedRuleIds.includes(ruleId) && !notChosenRuleIdsRef.current.includes(ruleId);
            });
            succeededRuleIds.forEach(function (ruleId) {
              return accumulatedSuccessRef.current.add(ruleId);
            });
            recordFailedRules(failedRuleIds.map(ruleEntryOf));
            recordStepOutcome("finding_moved_changes", succeededRuleIds, failedRuleIds);
            step.completed = true;
            markStep("finding_moved_changes", stepStatusOf(leftEntries, failedRuleIds.length), stepDetailsOf("finding_moved_changes", leftEntries, failedRuleIds.length));
            _context20.n = 2;
            return tryComplete();
          case 2:
            return _context20.a(2);
        }
      }, _callee19);
    })));
  };

  /** The writes of a local run, in order, each its own step. */
  var enqueueLocalWrites = function enqueueLocalWrites(entries, input, leftForTheServer, placedInput) {
    enqueueApply("applying_redlines", [].concat(_toConsumableArray(entries.mergeData), _toConsumableArray(entries.besideParagraphCards)), applyRedlinesThenRecord(input), "We had an error applying the changes.", "apply_merge_data", "local merge data");
    enqueueApply("applying_table_changes", entries.tableCards, applyTableCardsThenRecord(input), "We had an error applying the table changes.", "apply_table_cards", "local table cards");
    enqueueServerPass(leftForTheServer, placedInput);
    enqueueApply("adding_comments", entries.commentData, applyCommentsThenRecord("adding_comments"), "We had an error applying the comments.", "apply_comment_data", "local comment data");
  };

  /**
   * A local run: the fold reports itself as the conflict check, then the
   * entries go into the apply chain. A fold that throws ends the run with the
   * error as the reason; nothing has been written yet at that point.
   */
  var startLocalRun = /*#__PURE__*/function () {
    var _ref36 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(input) {
      var foldStepFinished, chat, conversationId, reportSlotFailure, slotInsertionsOfRun, placedInput, _yield$timedBulkApply, laidOnTheirParagraphs, placedBesideParagraphs, leftForTheServer, documentPagesOfTheRun, foldedInput, entries, message, _i, _LOCAL_STEP_KEYS, step, state, _t13, _t14, _t15, _t16, _t17, _t18, _t19;
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.p = _context21.n) {
          case 0:
            foldStepFinished = function foldStepFinished(step) {
              var state = stepsRef.current[step];
              if (state) state.completed = true;
            };
            _context21.p = 1;
            setHiddenStepKeys(["finding_moved_changes"]);
            markStep("checking_conflicts", "IN_PROGRESS");
            chat = chatRef.current;
            conversationId = chat.selectedConversationId;
            reportSlotFailure = function reportSlotFailure(cardId, failure) {
              return sendError(failure instanceof Error ? failure : new Error(String(failure)), {
                component: "BulkApplyRunProvider",
                action: "place_insertions_in_slots",
                cardId: cardId
              });
            };
            slotInsertionsOfRun = function slotInsertionsOfRun(runConversationId) {
              var signedInHeader = chat.authHeader;
              return (0, _redlineInsertionSlot.orderedSlotInsertionsOf)({
                conversationId: runConversationId,
                turns: chat.messagesHistory,
                anchorBookmarks: (0, _redlineInsertionSlot.insertionAnchorsOf)(input.remedies),
                page: _redlineInsertionSlot.officeSlotPage,
                orderInsertion: signedInHeader === null ? null : function (request) {
                  return (0, _api.orderInsertion)(signedInHeader, request);
                },
                reportFailure: reportSlotFailure
              });
            };
            if (!(conversationId === undefined)) {
              _context21.n = 2;
              break;
            }
            _t13 = [];
            _context21.n = 4;
            break;
          case 2:
            _context21.n = 3;
            return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("slot_insertions_read", function () {
              return slotInsertionsOfRun(conversationId);
            });
          case 3:
            _t13 = _context21.v;
          case 4:
            slotInsertionsSharedWithTableStepRef.current = _t13;
            if (!(conversationId === undefined)) {
              _context21.n = 5;
              break;
            }
            _t14 = input;
            _context21.n = 7;
            break;
          case 5:
            _t15 = _objectSpread;
            _t16 = _objectSpread({}, input);
            _t17 = {};
            _context21.n = 6;
            return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("remedy_insertions_placed", function () {
              return (0, _redlineInsertionSlot.placeRemedyInsertionsInSlots)(input.remedies, slotInsertionsSharedWithTableStepRef.current, _redlineInsertionSlot.officeSlotPage, reportSlotFailure);
            });
          case 6:
            _t18 = _context21.v;
            _t14 = _t15(_t16, _t17, {
              remedies: _t18
            });
          case 7:
            placedInput = _t14;
            _context21.n = 8;
            return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("first_pass_placement", function () {
              return firstPassOf(placedInput.remedies);
            }, {
              cards: placedInput.remedies.length
            });
          case 8:
            _yield$timedBulkApply = _context21.v;
            laidOnTheirParagraphs = _yield$timedBulkApply.laidOnTheirParagraphs;
            placedBesideParagraphs = _yield$timedBulkApply.placedBesideParagraphs;
            leftForTheServer = _yield$timedBulkApply.leftForTheServer;
            documentPagesOfTheRun = _yield$timedBulkApply.documentPages;
            foldedInput = _objectSpread(_objectSpread({}, placedInput), {}, {
              remedies: laidOnTheirParagraphs,
              remediesPlacedBesideParagraphs: placedBesideParagraphs,
              documentPagesOfTheRun: documentPagesOfTheRun
            });
            _context21.n = 9;
            return (0, _bulkApplyRunTimeline.timedBulkApplySpan)("fold", function () {
              return (0, _redlineBulkApplyLocal.localBulkApplyEntries)(foldedInput, {
                stepStarted: function stepStarted(step) {
                  return markStep(step, "IN_PROGRESS");
                },
                stepFinished: function stepFinished(step, details) {
                  foldStepFinished(step);
                  markStep(step, "COMPLETED", details);
                }
              });
            }, {
              cards: laidOnTheirParagraphs.length
            });
          case 9:
            entries = _context21.v;
            recordFold(entries, placedInput.remedies);
            setHiddenStepKeys([].concat(_toConsumableArray(entries.tableCards.length === 0 ? ["applying_table_changes"] : []), _toConsumableArray(leftForTheServer.length === 0 ? ["finding_moved_changes"] : []), _toConsumableArray(entries.commentData.length === 0 ? ["adding_comments"] : [])));
            enqueueLocalWrites(entries, foldedInput, leftForTheServer, placedInput);
            _context21.n = 11;
            break;
          case 10:
            _context21.p = 10;
            _t19 = _context21.v;
            message = _t19 instanceof Error ? _t19.message : String(_t19);
            (0, _toast.toastError)((0, _errors.isWordBusyRefusal)(_t19) ? _errors.WORD_BUSY_MESSAGE : "We could not prepare these changes for the document.");
            sendError(_t19 instanceof Error ? _t19 : new Error(message), {
              component: "BulkApplyRunProvider",
              action: "fold_local_run"
            });
            for (_i = 0, _LOCAL_STEP_KEYS = LOCAL_STEP_KEYS; _i < _LOCAL_STEP_KEYS.length; _i++) {
              step = _LOCAL_STEP_KEYS[_i];
              state = stepsRef.current[step];
              if (state && !state.completed) markStep(step, "FAILED", (0, _errors.userMessageOf)(_t19));
            }
            _context21.n = 11;
            return stopTheRunHere();
          case 11:
            return _context21.a(2);
        }
      }, _callee20, null, [[1, 10]]);
    }));
    return function startLocalRun(_x26) {
      return _ref36.apply(this, arguments);
    };
  }();
  var scheduleNextPoll = function scheduleNextPoll(generation) {
    if (!isPollingRef.current || generation !== pollGenerationRef.current) return;
    if (pollingRef.current) clearTimeout(pollingRef.current);
    var backoff = Math.min(BULK_APPLY_POLL_INTERVAL_MS * Math.pow(2, consecutivePollFailuresRef.current), BULK_APPLY_POLL_MAX_BACKOFF_MS);
    pollingRef.current = setTimeout(function () {
      return pollStatus(generation);
    }, backoff);
  };
  var pollStatus = /*#__PURE__*/function () {
    var _ref37 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(generation) {
      var statusFileUrl, _data$gathering_data, _data$finding_conflic, _data$solving_conflic, _data$merging_non_con, _data$merging_non_con2, _data$merging_conflic, _data$merging_conflic2, _data$applying_commen2, _data$applying_commen3, response, parsedStatus, unreadableFields, data, statusSnapshot, failedPipelineStep, _steps, _data$solving_conflic2, _data$solving_conflic3, step3, step3MergeData, _data$merging_non_con3, _data$merging_non_con4, _data$merging_non_con5, _data$merging_non_con6, alreadyAppliedRuleIds, step5, step5MergeData, step6, step6CommentData, isFirstFailure, _t20, _t21;
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.p = _context22.n) {
          case 0:
            statusFileUrl = statusFileUrlRef.current;
            if (!(!statusFileUrl || !isPollingRef.current || generation !== pollGenerationRef.current)) {
              _context22.n = 1;
              break;
            }
            return _context22.a(2);
          case 1:
            if (!(lastProgressAtRef.current && Date.now() - lastProgressAtRef.current > BULK_APPLY_STALL_TIMEOUT_MS)) {
              _context22.n = 3;
              break;
            }
            (0, _toast.toastError)(BULK_APPLY_STALL_MESSAGE);
            sendError(new Error(BULK_APPLY_STALL_MESSAGE), {
              component: "BulkApplyRunProvider",
              action: "poll_status",
              statusFileUrl: statusFileUrl
            });
            _context22.n = 2;
            return stopTheRunHere();
          case 2:
            return _context22.a(2);
          case 3:
            _context22.p = 3;
            _context22.n = 4;
            return (0, _safeFetch.safeFetch)(statusFileUrl);
          case 4:
            response = _context22.v;
            _t20 = bulkApplyStatusSchema;
            _context22.n = 5;
            return response.json();
          case 5:
            parsedStatus = _t20.safeParse.call(_t20, _context22.v);
            if (!(generation !== pollGenerationRef.current)) {
              _context22.n = 6;
              break;
            }
            return _context22.a(2);
          case 6:
            consecutivePollFailuresRef.current = 0;
            if (parsedStatus.success) {
              _context22.n = 8;
              break;
            }
            unreadableFields = parsedStatus.error.issues.map(function (issue) {
              return issue.path.join(".");
            }).join(", ");
            sendError(new Error("Bulk apply status file does not match the add-in's contract at: ".concat(unreadableFields)), {
              component: "BulkApplyRunProvider",
              action: "poll_status",
              statusFileUrl: statusFileUrl
            });
            _context22.n = 7;
            return stopTheRunHere();
          case 7:
            return _context22.a(2);
          case 8:
            data = parsedStatus.data;
            statusSnapshot = stepProgressFingerprint(data);
            if (statusSnapshot !== lastStatusSnapshotRef.current) {
              lastStatusSnapshotRef.current = statusSnapshot;
              lastProgressAtRef.current = Date.now();
              setStepRecords(Object.fromEntries(PIPELINE_STEP_KEYS.map(function (key) {
                var _data$key$status2, _data$key3, _data$key$details2, _data$key4;
                return [key, {
                  status: (_data$key$status2 = (_data$key3 = data[key]) === null || _data$key3 === void 0 ? void 0 : _data$key3.status) !== null && _data$key$status2 !== void 0 ? _data$key$status2 : "QUEUED",
                  details: (_data$key$details2 = (_data$key4 = data[key]) === null || _data$key4 === void 0 ? void 0 : _data$key4.details) !== null && _data$key$details2 !== void 0 ? _data$key$details2 : null
                }];
              })));
            }
            failedPipelineStep = REDLINE_PIPELINE_STEP_KEYS.find(function (stepKey) {
              var _data$stepKey;
              return ((_data$stepKey = data[stepKey]) === null || _data$stepKey === void 0 ? void 0 : _data$stepKey.status) === "FAILED";
            });
            if (!failedPipelineStep) {
              _context22.n = 10;
              break;
            }
            _context22.n = 9;
            return stopTheRunHere();
          case 9:
            return _context22.a(2);
          case 10:
            settleTheCommentStepTheServerFailed(data);
            _steps = stepsRef.current;
            if (((_data$gathering_data = data.gathering_data) === null || _data$gathering_data === void 0 ? void 0 : _data$gathering_data.status) === "COMPLETED" && _steps.gathering_data) _steps.gathering_data.completed = true;
            if (((_data$finding_conflic = data.finding_conflicts) === null || _data$finding_conflic === void 0 ? void 0 : _data$finding_conflic.status) === "COMPLETED" && _steps.finding_conflicts) _steps.finding_conflicts.completed = true;
            if (((_data$solving_conflic = data.solving_conflicts) === null || _data$solving_conflic === void 0 ? void 0 : _data$solving_conflic.status) === "COMPLETED" && _steps.solving_conflicts) {
              _steps.solving_conflicts.completed = true;
              recordFailedRules((_data$solving_conflic2 = (_data$solving_conflic3 = data.solving_conflicts) === null || _data$solving_conflic3 === void 0 || (_data$solving_conflic3 = _data$solving_conflic3.data) === null || _data$solving_conflic3 === void 0 ? void 0 : _data$solving_conflic3.error_changes) !== null && _data$solving_conflic2 !== void 0 ? _data$solving_conflic2 : []);
            }
            step3 = _steps.merging_non_conflicting_issues;
            step3MergeData = (_data$merging_non_con = data.merging_non_conflicting_issues) === null || _data$merging_non_con === void 0 || (_data$merging_non_con = _data$merging_non_con.data) === null || _data$merging_non_con === void 0 ? void 0 : _data$merging_non_con.merge_data;
            if (((_data$merging_non_con2 = data.merging_non_conflicting_issues) === null || _data$merging_non_con2 === void 0 ? void 0 : _data$merging_non_con2.status) === "COMPLETED" && step3 && !step3.completed) {
              recordFailedRules((_data$merging_non_con3 = (_data$merging_non_con4 = data.merging_non_conflicting_issues) === null || _data$merging_non_con4 === void 0 || (_data$merging_non_con4 = _data$merging_non_con4.data) === null || _data$merging_non_con4 === void 0 ? void 0 : _data$merging_non_con4.error_changes) !== null && _data$merging_non_con3 !== void 0 ? _data$merging_non_con3 : []);
              alreadyAppliedRuleIds = collectRuleIds((_data$merging_non_con5 = (_data$merging_non_con6 = data.merging_non_conflicting_issues) === null || _data$merging_non_con6 === void 0 || (_data$merging_non_con6 = _data$merging_non_con6.data) === null || _data$merging_non_con6 === void 0 ? void 0 : _data$merging_non_con6.already_applied_changes) !== null && _data$merging_non_con5 !== void 0 ? _data$merging_non_con5 : []);
              alreadyAppliedRuleIds.forEach(function (ruleId) {
                return accumulatedSuccessRef.current.add(ruleId);
              });
              recordStepOutcome("merging_non_conflicting_issues", alreadyAppliedRuleIds, []);
              if (step3MergeData) {
                enqueueApply("merging_non_conflicting_issues", step3MergeData, applyPipelineMergeThenRecord("merging_non_conflicting_issues"), "We had an error applying the changes.", "apply_merge_data", "step 3 merge data");
              } else {
                step3.completed = true;
              }
            }
            step5 = _steps.merging_conflicting_issues;
            step5MergeData = (_data$merging_conflic = data.merging_conflicting_issues) === null || _data$merging_conflic === void 0 || (_data$merging_conflic = _data$merging_conflic.data) === null || _data$merging_conflic === void 0 ? void 0 : _data$merging_conflic.merge_data;
            if (((_data$merging_conflic2 = data.merging_conflicting_issues) === null || _data$merging_conflic2 === void 0 ? void 0 : _data$merging_conflic2.status) === "COMPLETED" && step5 && !step5.completed) {
              if (step5MergeData) {
                enqueueApply("merging_conflicting_issues", step5MergeData, applyPipelineMergeThenRecord("merging_conflicting_issues"), "We had an error applying the changes.", "apply_merge_data", "step 5 merge data");
              } else {
                step5.completed = true;
              }
            }
            step6 = _steps.applying_comments;
            step6CommentData = (_data$applying_commen2 = data.applying_comments) === null || _data$applying_commen2 === void 0 || (_data$applying_commen2 = _data$applying_commen2.data) === null || _data$applying_commen2 === void 0 ? void 0 : _data$applying_commen2.comment_data;
            if (((_data$applying_commen3 = data.applying_comments) === null || _data$applying_commen3 === void 0 ? void 0 : _data$applying_commen3.status) === "COMPLETED" && step6 && !step6.completed) {
              if (step6CommentData) {
                enqueueApply("applying_comments", step6CommentData, applyCommentsThenRecord("applying_comments"), "We had an error applying the comments.", "apply_comment_data", "step 6 comment data");
              } else {
                step6.completed = true;
              }
            }
            _context22.n = 11;
            return tryComplete();
          case 11:
            scheduleNextPoll(generation);
            _context22.n = 13;
            break;
          case 12:
            _context22.p = 12;
            _t21 = _context22.v;
            console.error("Error polling status:", _t21);
            isFirstFailure = consecutivePollFailuresRef.current === 0;
            consecutivePollFailuresRef.current += 1;
            if (isFirstFailure) {
              (0, _toast.toastError)(_t21 instanceof Error ? _t21.message : "Unknown polling error");
              sendError(new Error("Error polling status: ".concat(_t21 instanceof Error ? _t21.message : "Unknown polling error")), {
                component: "BulkApplyRunProvider",
                action: "poll_status",
                statusFileUrl: statusFileUrl
              });
            }
            scheduleNextPoll(generation);
          case 13:
            return _context22.a(2);
        }
      }, _callee21, null, [[3, 12]]);
    }));
    return function pollStatus(_x27) {
      return _ref37.apply(this, arguments);
    };
  }();
  var resetRunState = function resetRunState() {
    if (pollingRef.current) {
      clearTimeout(pollingRef.current);
      pollingRef.current = null;
    }
    runCannotContinueRef.current = false;
    hasServerFailedStepRef.current = false;
    completionTriggeredRef.current = false;
    accumulatedSuccessRef.current = new Set();
    accumulatedFailedRef.current = new Set();
    heldBackCommentRuleIdsRef.current = new Set();
    writtenPackageOoxmlsRef.current = [];
    commentOutcomesRef.current = [];
    commentsNotWrittenRef.current = [];
    consecutivePollFailuresRef.current = 0;
    applyChainRef.current = Promise.resolve();
    failedRulesRef.current = [];
    droppedCardsRef.current = [];
    writtenLandingTargetsRef.current = [];
    notChosenRuleIdsRef.current = [];
    notChosenCardsRef.current = [];
    partlySupersededCardsRef.current = [];
    cardsAsWrittenRef.current = [];
    foldPartlyAppliedCardsRef.current = [];
    succeededByStepRef.current = new Map();
    failedByStepRef.current = new Map();
    partiallyAppliedRuleIdsRef.current = [];
    partiallyAppliedCardsRef.current = [];
    mergeWritesRef.current = [];
    bodyReadOfTheMergesRef.current = null;
    runStartedAtMsRef.current = Date.now();
    lastStatusSnapshotRef.current = null;
    lastProgressAtRef.current = Date.now();
    setFailedRules([]);
    setFailedCardDetails([]);
    setApplyProgress(null);
    setAppliedRuleCount(0);
    setCommentsNotAddedCount(0);
    setOutcome(null);
    setIsRepairing(false);
    setStepRecords({});
    setHiddenStepKeys([]);
  };

  /**
   * Starts the run and opens the panel. The source may still be resolving (a
   * pipeline job being posted); the run reads as started meanwhile so the caller's
   * button reflects it. A new run replaces the previous one's view.
   */
  var startRun = (0, _react.useCallback)(function (nextRequest) {
    if (isRunningRef.current) return false;
    isRunningRef.current = true;
    var generation = ++pollGenerationRef.current;
    requestRef.current = nextRequest;
    setRequest(nextRequest);
    resetRunState();
    timelineRunRef.current = (0, _bulkApplyRunTimeline.beginBulkApplyTimeline)();
    setIsRunning(true);
    setIsPanelOpen(true);
    isPollingRef.current = true;
    runKindRef.current = null;
    setRunKind(null);
    (0, _bulkApplyRunTimeline.timedBulkApplySpan)("source_resolved", function () {
      return Promise.resolve(nextRequest.source);
    }).then(function (source) {
      if (generation !== pollGenerationRef.current) return;
      runKindRef.current = source.kind;
      setRunKind(source.kind);
      stepsRef.current = createStepStates(source.kind);
      statusFileUrlRef.current = source.kind === "pipeline" ? source.statusFileUrl : "";
      pipelineRemediesRef.current = source.kind === "pipeline" ? source.remedies : [];
      remediesOfTheRunRef.current = source.kind === "pipeline" ? source.remedies : source.input.remedies;
      if (source.kind === "local") void startLocalRun(source.input);else void pollStatus(generation);
    }).catch(/*#__PURE__*/function () {
      var _ref38 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(error) {
        var message;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              if (!(generation !== pollGenerationRef.current)) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2);
            case 1:
              message = error instanceof Error ? error.message : String(error);
              sendError(error instanceof Error ? error : new Error(message), {
                component: "BulkApplyRunProvider",
                action: "start_bulk_apply"
              });
              stepsRef.current = {};
              _context23.n = 2;
              return stopTheRunHere();
            case 2:
              return _context23.a(2);
          }
        }, _callee22);
      }));
      return function (_x28) {
        return _ref38.apply(this, arguments);
      };
    }());
    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Awaits in-flight writes before closing, so the panel does not disappear while Office API calls are still running; the run itself keeps going. */
  var closePanel = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
    var _t22;
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.p = _context24.n) {
        case 0:
          _context24.p = 0;
          _context24.n = 1;
          return applyChainRef.current;
        case 1:
          _context24.n = 3;
          break;
        case 2:
          _context24.p = 2;
          _t22 = _context24.v;
        case 3:
          setIsPanelOpen(false);
        case 4:
          return _context24.a(2);
      }
    }, _callee23, null, [[0, 2]]);
  })), []);
  var steps = (0, _react.useMemo)(function () {
    return runKind === null ? [] : stepKeysOf(runKind).filter(function (key) {
      return !hiddenStepKeys.includes(key);
    }).map(function (key) {
      var _stepRecords$key$stat, _stepRecords$key, _stepRecords$key$deta, _stepRecords$key2;
      return {
        key: key,
        title: STEP_TITLES[key],
        description: STEP_DESCRIPTIONS[key],
        status: (_stepRecords$key$stat = (_stepRecords$key = stepRecords[key]) === null || _stepRecords$key === void 0 ? void 0 : _stepRecords$key.status) !== null && _stepRecords$key$stat !== void 0 ? _stepRecords$key$stat : "QUEUED",
        details: (_stepRecords$key$deta = (_stepRecords$key2 = stepRecords[key]) === null || _stepRecords$key2 === void 0 ? void 0 : _stepRecords$key2.details) !== null && _stepRecords$key$deta !== void 0 ? _stepRecords$key$deta : null
      };
    });
  }, [runKind, stepRecords, hiddenStepKeys]);
  var applyBar = (0, _react.useMemo)(function () {
    return resolveApplyBar(steps, isRepairing, applyProgress, outcome, appliedRuleCount, failedRules.length, commentsNotAddedCount);
  }, [steps, isRepairing, applyProgress, outcome, appliedRuleCount, failedRules.length, commentsNotAddedCount]);
  var value = (0, _react.useMemo)(function () {
    return {
      request: request,
      runKind: runKind,
      isPanelOpen: isPanelOpen,
      isRunning: isRunning,
      steps: steps,
      applyBar: applyBar,
      failedRules: failedRules,
      failedCardDetails: failedCardDetails,
      outcome: outcome,
      startRun: startRun,
      closePanel: closePanel
    };
  }, [request, runKind, isPanelOpen, isRunning, steps, applyBar, failedRules, failedCardDetails, outcome, startRun, closePanel]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(BulkApplyRunContext.Provider, {
    value: value,
    "data-sentry-element": "BulkApplyRunContext.Provider",
    "data-sentry-component": "BulkApplyRunProvider",
    "data-sentry-source-file": "BulkApplyRunContext.tsx",
    children: children
  });
};
function useBulkApplyRun() {
  var context = (0, _react.useContext)(BulkApplyRunContext);
  if (!context) throw new Error("useBulkApplyRun must be used within a BulkApplyRunProvider");
  return context;
}